!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.strapiIcons = e(require("react")) : t.strapiIcons = e(t.react);
}(this, function (t) {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var a = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var a in t) n.d(r, a, function (e) {
        return t[e];
      }.bind(null, a));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 195);
  }([function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 2a8.5 8.5 0 018.5 8.5c0 6.5-5.5 12-8.5 12s-8.5-5.5-8.5-12A8.5 8.5 0 0112 2zm5.5 10a4.5 4.5 0 00-4.475 4.975 4.5 4.5 0 004.95-4.95A4.54 4.54 0 0017.5 12zm-11 0c-.16 0-.319.008-.475.025a4.5 4.5 0 004.95 4.95A4.5 4.5 0 006.5 12z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M14 10v4h-4v-4h4zm2 0h5v4h-5v-4zm-2 11h-4v-5h4v5zm2 0v-5h5v4a1 1 0 01-1 1h-4zM14 3v5h-4V3h4zm2 0h4a1 1 0 011 1v4h-5V3zm-8 7v4H3v-4h5zm0 11H4a1 1 0 01-1-1v-4h5v5zM8 3v5H3V4a1 1 0 011-1h4z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M3 10h18v10.004c0 .55-.445.996-.993.996H3.993A.994.994 0 013 20.004V10zm6 2v2h6v-2H9zM2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.444.992 1v4H2V4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M13.3 0c.11 0 .2.09.2.2v18.06l8.238-8.239a.2.2 0 01.283 0l1.837 1.838a.2.2 0 010 .282L12.141 23.86a.2.2 0 01-.283 0L.141 12.14a.2.2 0 010-.282l1.837-1.838a.2.2 0 01.283 0L10.5 18.26V.2c0-.11.09-.2.2-.2h2.6z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M24 13.3a.2.2 0 01-.2.2H5.74l8.239 8.239a.2.2 0 010 .282L12.14 23.86a.2.2 0 01-.282 0L.14 12.14a.2.2 0 010-.282L11.86.14a.2.2 0 01.282 0L13.98 1.98a.2.2 0 010 .282L5.74 10.5H23.8c.11 0 .2.09.2.2v2.6z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 10.7c0-.11.09-.2.2-.2h18.06l-8.239-8.239a.2.2 0 010-.282L11.86.14a.2.2 0 01.282 0L23.86 11.86a.2.2 0 010 .282L12.14 23.86a.2.2 0 01-.282 0L10.02 22.02a.2.2 0 010-.282L18.26 13.5H.2a.2.2 0 01-.2-.2v-2.6z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M10.7 24a.2.2 0 01-.2-.2V5.74L2.26 13.979a.2.2 0 01-.283 0L.141 12.14a.2.2 0 010-.282L11.858.14a.2.2 0 01.283 0L23.858 11.86a.2.2 0 010 .282l-1.837 1.838a.2.2 0 01-.283 0L13.5 5.74V23.8a.2.2 0 01-.2.2h-2.6z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M14 13.5V8a4 4 0 10-8 0v5.5a6.5 6.5 0 0013 0V4h2v9.5a8.5 8.5 0 11-17 0V8a6 6 0 1112 0v5.5a3.5 3.5 0 11-7 0V8h2v5.5a1.5 1.5 0 103 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1v2zM9.5 21h5a2.5 2.5 0 01-5 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.778 6H8v12h1.778V6zm6.444 3.333a3.32 3.32 0 01-.85 2.222 3.533 3.533 0 011.517 2.89c0 1.96-1.627 3.555-3.627 3.555H9.778v-1.777h3.484c1.02 0 1.85-.798 1.85-1.778s-.83-1.778-1.85-1.778H9.778v-1.778h3.111c.858 0 1.556-.698 1.556-1.556 0-.857-.698-1.555-1.556-1.555H9.778V6h3.111a3.337 3.337 0 013.333 3.333z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M13 21v2.5l-3-2-3 2V21h-.5A3.5 3.5 0 013 17.5V5a3 3 0 013-3h14a1 1 0 011 1v17a1 1 0 01-1 1h-7zm-6-2v-2h6v2h6v-3H6.5a1.5 1.5 0 100 3H7zM7 5v2h2V5H7zm0 3v2h2V8H7zm0 3v2h2v-2H7z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#EAFBE7",
        stroke: "#C6F0C2"
      }), r.createElement("path", {
        d: "M19.5 7h-7A4.505 4.505 0 008 11.5c0 2.481 2.019 4.5 4.5 4.5h7c2.481 0 4.5-2.019 4.5-4.5S21.981 7 19.5 7zm0 8a3.5 3.5 0 110-7 3.5 3.5 0 010 7z",
        fill: "#328048"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M7 5V2a1 1 0 011-1h8a1 1 0 011 1v3h4a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h4zm10 8v-3h-2v3H9v-3H7v3H4v6h16v-6h-3zM9 3v2h6V3H9z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M13.289 6.216l4.939-3.841a1 1 0 011.32.082l2.995 2.994a1 1 0 01.082 1.321l-3.84 4.938a7.504 7.504 0 01-7.283 9.292C8 21.002 3.5 19.5 1 18c3.98-3 3.047-4.81 3.5-6.5 1.058-3.95 4.842-6.257 8.789-5.284zm3.413 1.879c.065.063.13.128.193.194l1.135 1.134 2.475-3.182-1.746-1.746-3.182 2.475 1.125 1.125z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.585 8.77a1.385 1.385 0 110-2.77 1.385 1.385 0 010 2.77zm3.23-2.223h9v1.539h-9V6.547zM5.2 12a1.385 1.385 0 102.77 0 1.385 1.385 0 00-2.77 0zm1.385 6a1.385 1.385 0 110-2.77 1.385 1.385 0 010 2.77zm12.23-6.837h-9V12.7h9v-1.538zm-9 4.615h9v1.539h-9v-1.539z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.869 2.99V0h2.9v2.99h10.463V0h2.9v2.99h.629c2.768 0 3.203.498 3.239 2.926V21c0 2.124-.191 3-2.802 3H2.818C.208 24 0 23.363 0 20.785V6.21c.035-2.049.233-3.22 3.001-3.22h.868zM2.32 20.369c0 .811.245.865.776.865h17.905c.53 0 .68-.012.68-.825V8.233c-.015-.627-.219-.737-.631-.737H2.907c-.413 0-.592.09-.587.573v12.3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M19 20H5v1a1 1 0 01-1 1H3a1 1 0 01-1-1v-9l2.513-6.702A2 2 0 016.386 4h11.228a2 2 0 011.873 1.298L22 12v9a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1zM4.136 12h15.728l-2.25-6H6.386l-2.25 6zM6.5 17a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 .889a.86.86 0 01-.26.625L7.615 7.736A.834.834 0 017 8a.834.834 0 01-.615-.264L.26 1.514A.861.861 0 010 .889c0-.24.087-.45.26-.625A.834.834 0 01.875 0h12.25c.237 0 .442.088.615.264a.86.86 0 01.26.625z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 7.111c0-.24.087-.449.26-.625L6.385.264A.834.834 0 017 0c.237 0 .442.088.615.264l6.125 6.222a.86.86 0 01.26.625.86.86 0 01-.26.625.834.834 0 01-.615.264H.875a.834.834 0 01-.615-.264.86.86 0 01-.26-.625z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1h-6c0-.67-.051-1.338-.153-2H20V5H4v3.153A13.1 13.1 0 002 8V4a1 1 0 011-1zm10 18h-2a9 9 0 00-9-9v-2c6.075 0 11 4.925 11 11zm-4 0H7a5 5 0 00-5-5v-2a7 7 0 017 7zm-4 0H2v-3a3 3 0 013 3zm9.373-4A13.033 13.033 0 006 8.627V7h12v10h-3.627z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M16 16a3 3 0 110 6 3 3 0 010-6zM6 12c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm8.5-10a5.5 5.5 0 110 11 5.5 5.5 0 010-11z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M11 2.05v3.02a7 7 0 105.192 12.536l2.137 2.137A9.966 9.966 0 0112 22C6.477 22 2 17.523 2 12c0-5.185 3.947-9.449 9-9.95zM21.95 13a9.947 9.947 0 01-2.207 5.328l-2.137-2.136A6.958 6.958 0 0018.929 13h3.022-.001zM13.002 2.05a10.004 10.004 0 018.95 8.95H18.93a7.005 7.005 0 00-5.928-5.929V2.049v.001z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M11 2.05V13h10.95c-.501 5.053-4.765 9-9.95 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95zm2-1.507C18.553 1.02 22.979 5.447 23.457 11H13V.543z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M20.727 2.97a.2.2 0 01.286 0l2.85 2.89a.2.2 0 010 .28L9.554 20.854a.2.2 0 01-.285 0l-9.13-9.243a.2.2 0 010-.281l2.85-2.892a.2.2 0 01.284 0l6.14 6.209L20.726 2.97z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm-1.438-11.066L16.158 7.5 18 9.245l-7.438 7.18-4.462-4.1 1.84-1.745 2.622 2.354z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 17 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M15.06.06L8.94 6.167 2.82.06.94 1.94l8 8 8-8L15.06.06z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 10 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M9.88 14.12L3.773 8 9.88 1.88 8 0 0 8l8 8 1.88-1.88z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 10 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 1.88L6.107 8 0 14.12 1.88 16l8-8-8-8L0 1.88z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 17 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M1.94 9.94l6.12-6.107 6.12 6.107 1.88-1.88-8-8-8 8 1.88 1.88z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 12C0 5.37 5.364 0 11.994 0S24 5.37 24 12s-5.376 12-12.006 12S0 18.63 0 12zm2.4 0c0 5.304 4.296 9.6 9.6 9.6 5.304 0 9.6-4.296 9.6-9.6 0-5.304-4.296-9.6-9.6-9.6A9.597 9.597 0 002.4 12zm8.4-6h1.8v6.3l5.4 3.204-.906 1.476L10.8 13.2V6z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M17 7a8.003 8.003 0 00-7.493 5.19l1.874.703A6.002 6.002 0 0123.001 15a6 6 0 01-6 6H7A6 6 0 015.007 9.339a7 7 0 0113.757-2.143A8.027 8.027 0 0017 7z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M7 20.981a6.5 6.5 0 01-2.936-12 8.001 8.001 0 0115.872 0 6.5 6.5 0 01-2.936 12V21H7v-.019zM13 13h3l-4-5-4 5h3v4h2v-4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M10.613 14.475l-4.026-2.322 4.026-2.323V8L5 11.238v1.83l5.613 3.238v-1.83zM13.387 10.028l4.026 2.323-4.026 2.321v1.831L19 13.266v-1.831l-5.613-3.238v1.83z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 4a4 4 0 014-4h24a4 4 0 014 4v24a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
        fill: "#D9822F"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.143 18.659v2.912l6.856-3.878v-2.815L17.143 11v2.906l4.16 2.38-4.16 2.373zm-2.287 0l-4.16-2.374 4.16-2.38V11L8 14.877v2.816l6.856 3.878v-2.912z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.68 9.192c-.6.276-2.114 1.18-2.306 1.303a.792.792 0 00-.374.68v1.65a.797.797 0 00.384.687c.254.16 1.73 1.042 2.306 1.303l.744 1.8c-.24.634-.67 2.333-.72 2.554a.797.797 0 00.216.744l1.167 1.166a.801.801 0 00.744.216l.03-.008c.36-.092 1.946-.498 2.523-.712l1.8.744c.276.6 1.181 2.115 1.304 2.307a.805.805 0 00.679.374h1.649a.797.797 0 00.686-.384c.16-.254 1.042-1.73 1.303-2.306l1.8-.744c.634.24 2.333.67 2.554.72a.797.797 0 00.744-.216l1.166-1.167a.803.803 0 00.216-.744l-.008-.03c-.092-.36-.498-1.946-.712-2.523l.744-1.8c.6-.276 2.115-1.181 2.307-1.304a.804.804 0 00.374-.679v-1.649a.796.796 0 00-.382-.679c-.254-.16-1.73-1.041-2.306-1.303l-.744-1.8c.24-.634.67-2.333.72-2.554a.796.796 0 00-.216-.744l-1.166-1.173a.802.802 0 00-.744-.216l-.03.008c-.361.092-1.947.498-2.524.712l-1.8-.744c-.276-.6-1.18-2.115-1.303-2.307a.803.803 0 00-.68-.374h-1.65a.797.797 0 00-.68.382c-.16.254-1.041 1.73-1.303 2.306l-1.8.744c-.634-.24-2.333-.67-2.554-.72a.797.797 0 00-.744.216L2.921 4.094a.802.802 0 00-.216.744l.008.03c.092.361.498 1.947.712 2.524l-.744 1.8zM12 17a5 5 0 100-10 5 5 0 000 10z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M2.743 2.743H0v1.371h4.114V0H2.743v2.743zM12 2.743H9.257V0H7.886v4.114H12V2.743zM4.114 7.885H0v1.371h2.743V12h1.371V7.885zM9.257 9.256H12V7.885H7.886v4.114h1.371V9.256z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#4945FF",
        stroke: "#4945FF"
      }), r.createElement("path", {
        d: "M15.328 10.54h1.723c.012-.089.012-.165.012-.253 0-1.676-1.471-2.959-3.41-2.959-2.696 0-4.647 2.22-4.647 5.344 0 2.15 1.383 3.545 3.504 3.545 2.045 0 3.597-1.154 3.967-2.936h-1.752c-.276.826-1.102 1.371-2.063 1.371-1.137 0-1.846-.802-1.846-2.103 0-2.08 1.19-3.65 2.725-3.65 1.037 0 1.746.62 1.787 1.558v.082zM21.053 16l1.488-6.943h2.531l.31-1.512H18.54l-.31 1.512h2.53L19.272 16h1.782z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M3.98.027a4.485 4.485 0 00-1.64.507C.885 1.308 0 2.802 0 4.485 0 6.759 1.577 8.628 3.828 9.02c.267.047.715.06 2.037.06H7.56v5.84H5.95c-.928 0-1.762.019-1.97.044a4.474 4.474 0 00-1.445.435C.974 16.165 0 17.747 0 19.515c0 1.229.451 2.328 1.304 3.181a4.387 4.387 0 006.234.002c.573-.572.945-1.225 1.174-2.058l.105-.38.014-2.01.014-2.01h6.31l.014 2.01.014 2.01.105.38c.39 1.419 1.329 2.5 2.624 3.022.536.217.902.296 1.491.326a4.345 4.345 0 003.294-1.293c.85-.85 1.303-1.955 1.303-3.18 0-2.327-1.7-4.271-3.98-4.551-.208-.025-1.042-.044-1.97-.044h-1.61V9.08h1.695c1.832 0 2.058-.019 2.712-.224C22.719 8.269 24 6.492 24 4.485c0-1.185-.44-2.297-1.231-3.109C21.429-.001 19.426-.381 17.73.42c-1.244.588-2.069 1.58-2.442 2.94l-.105.38-.014 2.03-.014 2.03h-6.31l-.014-2.03-.014-2.03-.105-.38C8.427 2.323 7.877 1.498 7.06.883 6.712.621 5.998.269 5.6.163 5.094.028 4.427-.028 3.98.027m1.132 1.317c.932.192 1.765.871 2.185 1.782.249.539.263.691.263 2.816v1.906l-1.73-.019c-1.853-.02-1.992-.034-2.509-.242-.422-.171-.689-.355-1.081-.747-.526-.527-.779-.982-.902-1.625-.077-.399-.074-1.102.006-1.487.234-1.136 1.227-2.14 2.357-2.382a4.203 4.203 0 011.411-.002m15.16 0c1.15.237 2.147 1.234 2.384 2.384.08.385.083 1.088.006 1.487-.123.643-.376 1.098-.902 1.625-.392.392-.659.576-1.081.747-.517.208-.656.222-2.509.242l-1.73.019V5.942c0-2.125.014-2.277.263-2.816.414-.898 1.247-1.584 2.158-1.78a4.203 4.203 0 011.411-.002M15.16 12v2.96H8.84V9.04h6.32V12m-7.6 6.082c0 2.099-.015 2.254-.263 2.792a3.182 3.182 0 01-2.19 1.788c-.36.081-1.019.079-1.392-.005-1.16-.26-2.136-1.241-2.371-2.385-.129-.622-.063-1.504.15-2.032.347-.859 1.148-1.614 2.017-1.898.371-.121.558-.133 2.319-.137l1.73-.005v1.882m12.86-1.766c.943.314 1.728 1.037 2.086 1.924.208.516.279 1.426.156 2.007a3.185 3.185 0 01-2.377 2.41c-.373.084-1.032.086-1.392.005a3.182 3.182 0 01-2.19-1.788c-.248-.538-.263-.693-.263-2.795v-1.884l1.85.014c1.811.014 1.856.016 2.13.107",
        fillRule: "evenodd"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#F6F6F9",
        stroke: "#DCDCE4"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.535 8.768c0 .116-.011.229-.032.339l3.013 1.776 2.985-1.76a1.768 1.768 0 11.519.93l-2.982 1.757v2.477a1.768 1.768 0 11-1.048-.044v-2.435l-2.997-1.767a1.768 1.768 0 11.542-1.274z",
        fill: "#666687"
      }), r.createElement("path", {
        d: "M13.503 9.107l-.05-.01-.006.035.03.018.026-.043zm3.013 1.776l-.025.043.025.014.025-.014-.025-.043zm2.985-1.76l.025.044.031-.018-.007-.035-.05.01zm.518.93l.035-.036-.027-.026-.033.02.026.042zm-2.98 1.757l-.026-.043-.025.014v.029h.05zm0 2.477h-.05v.035l.032.012.017-.047zm-1.049-.044l.013.048.037-.01v-.038h-.05zm0-2.435h.05v-.029l-.024-.014-.026.043zm-2.997-1.767l.025-.043-.033-.019-.027.027.035.035zm.559-.925c.022-.113.033-.23.033-.348h-.1c0 .112-.01.223-.031.33l.098.018zm2.99 1.723l-3.014-1.775-.05.086 3.013 1.775.05-.086zm2.933-1.758l-2.984 1.758.05.086 2.985-1.758-.05-.086zm-.06-.313c0 .125.013.247.037.366l.098-.02a1.723 1.723 0 01-.035-.346h-.1zm1.818-1.818a1.818 1.818 0 00-1.818 1.818h.1c0-.949.769-1.718 1.718-1.718v-.1zm1.817 1.818a1.818 1.818 0 00-1.817-1.818v.1c.948 0 1.717.769 1.717 1.718h.1zm-1.817 1.817a1.818 1.818 0 001.817-1.817h-.1c0 .948-.769 1.717-1.717 1.717v.1zm-1.248-.495c.326.307.765.495 1.248.495v-.1c-.457 0-.872-.178-1.18-.468l-.068.073zm-2.921 1.763l2.98-1.757-.05-.086-2.981 1.757.05.086zm.024 2.434V11.81h-.1v2.477h.1zm-.067.047a1.718 1.718 0 011.14 1.618h.1c0-.79-.503-1.46-1.206-1.712l-.034.094zm1.14 1.618c0 .948-.77 1.717-1.718 1.717v.1a1.817 1.817 0 001.817-1.817h-.1zm-1.718 1.717a1.718 1.718 0 01-1.718-1.717h-.1c0 1.004.814 1.817 1.818 1.817v-.1zm-1.718-1.717c0-.797.543-1.467 1.278-1.66l-.026-.098a1.818 1.818 0 00-1.352 1.758h.1zm1.215-4.144v2.435h.1v-2.435h-.1zm-2.973-1.723l2.998 1.766.05-.086-2.997-1.767-.05.087zm-1.2.5c.49 0 .934-.193 1.26-.507l-.069-.072c-.309.296-.728.48-1.19.48v.1zM9.95 8.768c0 1.003.814 1.817 1.818 1.817v-.1a1.718 1.718 0 01-1.718-1.717h-.1zm1.818-1.818A1.818 1.818 0 009.95 8.768h.1c0-.949.769-1.718 1.717-1.718v-.1zm1.817 1.818a1.818 1.818 0 00-1.818-1.818v.1c.95 0 1.718.769 1.718 1.718h.1z",
        fill: "#666687"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M8 5h3v9H8v3H6v-3H3V5h3V2h2v3zm10 5h3v9h-3v3h-2v-3h-3v-9h3V7h2v3z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M20.571 21.429h-3.428V24h3.428v-2.571zM20.571 17.143V3.429H7.714v3.428h9.429v10.286H6.857V0H3.43v3.429H0v3.428h3.429v13.714H24v-3.428h-3.429z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M24 2.417L21.583 0 12 9.583 2.417 0 0 2.417 9.583 12 0 21.583 2.417 24 12 14.417 21.583 24 24 21.583 14.417 12 24 2.417z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "#212134"
      }), r.createElement("path", {
        d: "M16 8.806L15.194 8 12 11.194 8.806 8 8 8.806 11.194 12 8 15.194l.806.806L12 12.806 15.194 16l.806-.806L12.806 12 16 8.806z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M2.8 5.2L7 8l4.186-5.86a1 1 0 011.628 0L17 8l4.2-2.8a1 1 0 011.547.95l-1.643 13.967a1 1 0 01-.993.883H3.889a1 1 0 01-.993-.883L1.253 6.149A1 1 0 012.8 5.2zM12 15a2 2 0 100-4 2 2 0 000 4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M5 3h15a2 2 0 012 2v3a2 2 0 01-2 2h-2v3a4 4 0 01-4 4H8a4 4 0 01-4-4V4a1 1 0 011-1zm13 2v3h2V5h-2zM2 19h18v2H2v-2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M13.91 12.36L17 20.854l-2.818 1.026-3.092-8.494-4.172 3.156 1.49-14.909 10.726 10.463-5.224.264z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M21 9.5v3c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5v-3c0 2.485 4.03 4.5 9 4.5s9-2.015 9-4.5zm-18 5c0 2.485 4.03 4.5 9 4.5s9-2.015 9-4.5v3c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5v-3zm9-2.5c-4.97 0-9-2.015-9-4.5S7.03 3 12 3s9 2.015 9 4.5-4.03 4.5-9 4.5z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M.5 3A2.5 2.5 0 013 .5h26A2.5 2.5 0 0131.5 3v18a2.5 2.5 0 01-2.5 2.5H3A2.5 2.5 0 01.5 21V3z",
        fill: "#FDF4DC",
        stroke: "#FAE7B9"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.934 7.495V6h1.45v1.495h5.232V6h1.45v1.495h.314c1.385 0 1.602.249 1.62 1.463V16.5c0 1.062-.096 1.5-1.4 1.5h-9.19c-1.306 0-1.41-.318-1.41-1.607V9.105c.018-1.025.117-1.61 1.5-1.61h.434zm-.774 8.687c0 .406.123.433.388.433h8.953c.265 0 .34-.007.34-.413v-6.087c-.008-.314-.11-.369-.316-.369h-9.072c-.206 0-.296.045-.293.287v6.15z",
        fill: "#D9822F"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M20.04 0H3.96A2.464 2.464 0 001.5 2.468v16.2a2.464 2.464 0 002.46 2.469h13.608l-.636-2.217 1.536 1.426 1.452 1.342 2.58 2.277V2.468A2.464 2.464 0 0020.04 0zm-4.632 15.65s-.432-.516-.792-.972c1.572-.443 2.172-1.425 2.172-1.425-.492.323-.96.55-1.38.707-.6.251-1.176.419-1.74.515a8.417 8.417 0 01-3.108-.012 10.086 10.086 0 01-1.764-.515 7.053 7.053 0 01-.876-.408c-.036-.024-.072-.036-.108-.06a.166.166 0 01-.048-.036 4.202 4.202 0 01-.336-.203s.576.958 2.1 1.414c-.36.455-.804.994-.804.994-2.652-.084-3.66-1.821-3.66-1.821 0-3.859 1.728-6.986 1.728-6.986 1.728-1.294 3.372-1.258 3.372-1.258l.12.144c-2.16.623-3.156 1.57-3.156 1.57s.264-.144.708-.348c1.284-.563 2.304-.72 2.724-.755.072-.012.132-.024.204-.024A9.792 9.792 0 0116.8 7.297s-.948-.898-2.988-1.521l.168-.192s1.644-.036 3.372 1.258c0 0 1.728 3.127 1.728 6.986 0 0-1.02 1.737-3.672 1.821zm-5.58-5.597c-.684 0-1.224.6-1.224 1.33 0 .731.552 1.33 1.224 1.33.684 0 1.224-.599 1.224-1.33.012-.73-.54-1.33-1.224-1.33zm4.38 0c-.684 0-1.224.6-1.224 1.33 0 .731.552 1.33 1.224 1.33.684 0 1.224-.599 1.224-1.33 0-.73-.54-1.33-1.224-1.33z",
        fill: "#7289DA"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12.103 0C5.533 0 0 5.278 0 11.79V24l12.1-.012c6.57 0 11.9-5.481 11.9-11.992C24 5.486 18.666 0 12.103 0z",
        fill: "#231F20"
      }), r.createElement("path", {
        d: "M12.22 4.564a7.43 7.43 0 00-3.644.956 7.346 7.346 0 00-2.692 2.614 7.26 7.26 0 00-.149 7.22L4.4 19.606l4.793-1.072a7.433 7.433 0 006.355-.14 7.36 7.36 0 002.513-2.057 7.28 7.28 0 001.372-2.93 7.243 7.243 0 00-.035-3.228A7.281 7.281 0 0017.96 7.28a7.365 7.365 0 00-2.557-2.002 7.432 7.432 0 00-3.178-.715h-.007z",
        fill: "#FFF9AE"
      }), r.createElement("path", {
        d: "M18.071 7.426a7.262 7.262 0 011.51 4.499 7.264 7.264 0 01-1.595 4.47 7.38 7.38 0 01-4.028 2.558 7.437 7.437 0 01-4.765-.43L4.4 19.61l4.88-.571a7.432 7.432 0 005.181.858 7.381 7.381 0 004.443-2.778 7.258 7.258 0 00-.833-9.693z",
        fill: "#00AEEF"
      }), r.createElement("path", {
        d: "M16.713 6.078a7.253 7.253 0 01.86 8.928 7.361 7.361 0 01-3.736 2.962 7.437 7.437 0 01-4.784.065L4.4 19.61l4.793-1.075a7.436 7.436 0 005.24.313 7.362 7.362 0 004.123-3.22 7.249 7.249 0 00.914-5.123 7.296 7.296 0 00-2.757-4.427z",
        fill: "#00A94F"
      }), r.createElement("path", {
        d: "M6.176 15.515a7.246 7.246 0 01-.26-4.876 7.312 7.312 0 012.9-3.95 7.427 7.427 0 019.26.735 7.387 7.387 0 00-4.603-2.771 7.431 7.431 0 00-5.277 1.068A7.311 7.311 0 005.06 10.06a7.249 7.249 0 00.676 5.294L4.4 19.607l1.776-4.092z",
        fill: "#F15D22"
      }), r.createElement("path", {
        d: "M5.735 15.353a7.25 7.25 0 01-.764-4.818 7.294 7.294 0 012.465-4.222 7.415 7.415 0 014.596-1.744 7.42 7.42 0 014.681 1.509 7.404 7.404 0 00-4.865-2.26 7.421 7.421 0 00-5.12 1.61 7.293 7.293 0 00-2.66 4.626A7.256 7.256 0 005.28 15.24l-.877 4.37 1.332-4.257z",
        fill: "#E31B23"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M16.8 19L14 22.5 11.2 19H6a1 1 0 01-1-1V7.103a1 1 0 011-1h16a1 1 0 011 1V18a1 1 0 01-1 1h-5.2zM2 2h17v2H3v11H1V3a1 1 0 011-1z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M8 3v2H6v4c0 2.21 1.79 4 4 4s4-1.79 4-4V5h-2V3h3a1 1 0 011 1v5a6.002 6.002 0 01-5 5.917V16.5a3.5 3.5 0 006.775 1.237 3 3 0 112.049.148A5.5 5.5 0 019 16.5v-1.583A6 6 0 014 9V4a1 1 0 011-1h3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 4 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        width: 4,
        height: 4,
        rx: 2,
        fill: "#A5A5BA"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.571 5.85H10.43v8.47H2.487a.2.2 0 00-.14.343l9.512 9.401a.2.2 0 00.282 0l9.513-9.401a.2.2 0 00-.14-.342H13.57V5.85zM2.2 3.027a.2.2 0 01-.2-.2V.402c0-.11.09-.2.2-.2h19.6c.11 0 .2.09.2.2v2.423a.2.2 0 01-.2.2H2.2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M16.563 5.587a2.503 2.503 0 100-5.007 2.503 2.503 0 000 5.007z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M18.487 3.083c-.012.788-.487 1.513-1.229 1.797a1.954 1.954 0 01-2.184-.574A1.943 1.943 0 0114.9 2.11c.4-.684 1.2-1.066 1.981-.927a1.954 1.954 0 011.606 1.9c.011.748 1.17.748 1.158 0A3.138 3.138 0 0017.565.17c-1.176-.423-2.567-.03-3.36.933-.83 1.002-.968 2.45-.284 3.575.678 1.124 1.993 1.674 3.273 1.431 1.432-.272 2.428-1.593 2.451-3.019.012-.753-1.147-.753-1.158-.006zM16.563 14.372a2.503 2.503 0 100-5.007 2.503 2.503 0 000 5.007z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M18.487 11.867c-.012.789-.487 1.513-1.229 1.797a1.954 1.954 0 01-2.184-.574 1.943 1.943 0 01-.174-2.196c.4-.684 1.2-1.066 1.981-.927.928.156 1.588.968 1.606 1.9.011.748 1.17.748 1.158 0a3.138 3.138 0 00-2.08-2.914c-1.176-.423-2.567-.029-3.36.933-.83 1.002-.968 2.45-.284 3.575.678 1.124 1.993 1.675 3.273 1.431 1.432-.272 2.428-1.593 2.451-3.019.012-.753-1.147-.753-1.158-.005zM16.563 23.392a2.503 2.503 0 100-5.006 2.503 2.503 0 000 5.006z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M18.487 20.89c-.012.787-.487 1.512-1.229 1.796a1.954 1.954 0 01-2.184-.574 1.943 1.943 0 01-.174-2.196c.4-.684 1.2-1.066 1.981-.927.928.156 1.588.967 1.606 1.9.011.748 1.17.748 1.158 0a3.138 3.138 0 00-2.08-2.914c-1.176-.423-2.567-.03-3.36.933-.83 1.002-.968 2.45-.284 3.575.678 1.124 1.993 1.674 3.273 1.431 1.432-.272 2.428-1.593 2.451-3.019.012-.753-1.147-.753-1.158-.006zM7.378 5.622a2.503 2.503 0 100-5.007 2.503 2.503 0 000 5.007z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M9.302 3.119c-.011.788-.486 1.512-1.228 1.796a1.954 1.954 0 01-2.185-.574 1.943 1.943 0 01-.173-2.196c.4-.684 1.199-1.066 1.981-.927a1.943 1.943 0 011.605 1.9c.012.748 1.17.748 1.16 0A3.138 3.138 0 008.38.205c-1.176-.423-2.567-.029-3.36.933-.83 1.002-.968 2.45-.285 3.575.678 1.124 1.994 1.675 3.274 1.431 1.431-.272 2.428-1.593 2.451-3.019.012-.753-1.147-.753-1.159-.005zM7.378 14.406a2.503 2.503 0 100-5.006 2.503 2.503 0 000 5.006z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M9.302 11.902c-.011.788-.486 1.513-1.228 1.797a1.954 1.954 0 01-2.185-.574 1.943 1.943 0 01-.173-2.196c.4-.684 1.199-1.066 1.981-.927a1.943 1.943 0 011.605 1.9c.012.748 1.17.748 1.16 0A3.138 3.138 0 008.38 8.988c-1.176-.423-2.567-.03-3.36.933-.83 1.002-.968 2.45-.285 3.575.678 1.124 1.994 1.674 3.274 1.431 1.431-.272 2.428-1.593 2.451-3.019.012-.753-1.147-.753-1.159-.006zM7.378 23.427a2.503 2.503 0 100-5.007 2.503 2.503 0 000 5.007z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M9.302 20.924c-.011.788-.486 1.513-1.228 1.797a1.954 1.954 0 01-2.185-.574 1.943 1.943 0 01-.173-2.196c.4-.684 1.199-1.066 1.981-.927.933.156 1.594.967 1.605 1.9.012.748 1.17.748 1.16 0A3.139 3.139 0 008.38 18.01c-1.176-.423-2.567-.03-3.36.933-.83 1.002-.968 2.45-.285 3.569.678 1.124 1.994 1.675 3.274 1.431 1.431-.272 2.428-1.593 2.451-3.019.012-.747-1.147-.747-1.159 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M1.056 24h15.906c.583 0 1.056-.473 1.056-1.056V7.028c0-.583-.473-1.056-1.056-1.056H1.056C.473 5.972 0 6.445 0 7.028v15.916C0 23.527.473 24 1.056 24z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M8.094 2.111h13.795v13.795h-1.127v2.112h2.182A1.056 1.056 0 0024 16.962V1.056A1.056 1.056 0 0022.944 0H7.038a1.056 1.056 0 00-1.056 1.056v2.252h2.112V2.11z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#F6F6F9",
        stroke: "#DCDCE4"
      }), r.createElement("path", {
        d: "M20.573 8c-1.484 0-2.666.745-3.397 1.37l-.026.023-.416.452.919 1.51.68-.682c.711-.6 1.506-.93 2.24-.93 1.48 0 2.685 1.171 2.685 2.612 0 1.44-1.205 2.613-2.685 2.613-2.25 0-3.78-2.974-3.795-3.004C16.69 11.784 14.75 8 11.428 8 8.985 8 7 9.954 7 12.355c0 2.401 1.986 4.355 4.427 4.355 1.196 0 2.373-.476 3.404-1.376l.022-.02.413-.45-.919-1.51-.683.686c-.712.616-1.465.928-2.237.928-1.48 0-2.685-1.172-2.685-2.613 0-1.44 1.205-2.613 2.685-2.613 2.25 0 3.78 2.974 3.795 3.004.088.18 2.028 3.964 5.35 3.964 2.442 0 4.428-1.954 4.428-4.355C25 9.954 23.014 8 20.573 8z",
        fill: "#666687"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12.59 23.679l-.044-.007a.045.045 0 00.043.007zM22.334 8.345a.295.295 0 00-.572-.033.296.296 0 01-.28.206h-.828a.294.294 0 01-.153-.042l-1.199-.72a.293.293 0 00-.152-.042h-1.918a.294.294 0 00-.163.05l-2.366 1.577a.295.295 0 00-.131.248v2.236a.295.295 0 00.156.261l3.101 1.656a.298.298 0 01.157.257L18 15.257a.296.296 0 00.153.255l1.246.69a.297.297 0 01.152.258v2.604a.297.297 0 00.34.292.296.296 0 00.152-.07c.502-.443 1.223-1.09 1.319-1.237a11.186 11.186 0 001.175-2.415c.679-1.966.142-5.501-.203-7.289zM13.629 14.507l-3.286-2.464a.214.214 0 00-.129-.043H8.655a.203.203 0 01-.143-.06l-.735-.734a.216.216 0 00-.152-.063h-2.85a.202.202 0 01-.198-.243.203.203 0 01.055-.104l.451-.45a.202.202 0 01.144-.06H6.96a.428.428 0 00.413-.313l.369-1.312a.214.214 0 01.107-.132L9.32 7.77a.203.203 0 00.11-.18v-.67c0-.042.013-.082.037-.116l.782-1.126a.2.2 0 01.095-.074l1.095-.411a.203.203 0 00.131-.19v-.611a.203.203 0 00-.09-.17l-1.097-.729a.205.205 0 00-.206-.012l-1.493.747a.202.202 0 01-.214-.022l-.709-.56a.204.204 0 01.006-.321l.575-.424a.202.202 0 00-.005-.33l-.896-.625a.203.203 0 00-.214-.012c-.324.177-1.275.702-1.613.939a11.222 11.222 0 00-3.651 4.285c-.098.202-.218.407-.23.628-.012.221-.185.715-.258.915a.202.202 0 00.013.166l1.912 3.514a.2.2 0 00.074.077l2.012 1.207a.201.201 0 01.097.146l.403 2.922a.205.205 0 00.086.14l1.57 1.079a.214.214 0 01.088.133l.832 3.953a.193.193 0 00.027.066c.078.126.39.589.766.658-.035.01-.066.031-.101.041.09.016.18.037.268.063.107.028.214.053.321.076.168.033.184.06.265-.09.107-.2.23-.268.321-.292a.207.207 0 00.155-.156l.54-2.5a.215.215 0 01.085-.13l2.411-1.709a.214.214 0 00.09-.175v-3.212a.215.215 0 00-.082-.172z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M12.321.857s-.195.011-.235.012a11.113 11.113 0 00-3.932.845c.13.09-.094.173-.094.173l.35.684h1.876l1.285.643 1.125-.643-.375-1.714zM17.262 4.718l.863-.75a.214.214 0 00-.05-.357l-1.008-.467a.214.214 0 00-.284.101l-.415.869a.214.214 0 00.08.274l.56.35a.214.214 0 00.254-.02zM21.302 5.822l-.312-.483a.337.337 0 01-.014-.023c-.056-.115-.521-1.055-.91-1.42-.292-.276-.375-.196-.398-.135a.202.202 0 01-.064.085l-1.545 1.25a.214.214 0 01-.135.047h-.8a.214.214 0 00-.151.062l-.643.643a.215.215 0 000 .304l.643.642a.214.214 0 00.152.063h4.027a.215.215 0 00.214-.223l-.03-.705a.214.214 0 00-.034-.107z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M12 2.143A9.857 9.857 0 115.03 5.03 9.791 9.791 0 0112 2.143zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 21 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M18.54 8.746a.206.206 0 00-.07-.134.224.224 0 00-.14-.055.184.184 0 00-.14.04.227.227 0 00-.094.117.213.213 0 01-.078.119.216.216 0 01-.14.047h-.644a.214.214 0 01-.117 0l-.932-.567a.2.2 0 00-.117 0h-1.492a.184.184 0 00-.124 0L12.61 9.55a.244.244 0 00-.07.086.184.184 0 000 .11v1.765a.335.335 0 000 .119.251.251 0 00.093.086l2.41 1.3c.035.02.065.05.085.087a.24.24 0 01.039.118v.961a.335.335 0 000 .119c.022.032.051.059.085.079l.971.543a.297.297 0 01.086.087c.01.039.01.08 0 .118v2.056a.263.263 0 00.039.127.28.28 0 00.1.086c.041.012.084.012.125 0a.2.2 0 00.117-.055c.386-.292.752-.61 1.095-.953.125-.19.241-.394.35-.591.223-.42.412-.858.567-1.308.529-1.552.11-4.342-.163-5.744zM8.507 11.622l-2.332 4.05-.303-.213a.08.08 0 010-.047.088.088 0 010-.063l-.318-2.301a.088.088 0 000-.063.094.094 0 00-.047-.047l-1.554-.954a.156.156 0 01-.062-.063l-.863-1.576-.621-1.158v-.063a.232.232 0 010-.07c.074-.245.123-.495.147-.75.033-.174.093-.341.179-.496a8.834 8.834 0 012.82-3.38c.257-.181.995-.599 1.252-.733a.153.153 0 01.085 0 .16.16 0 01.078 0l.7.489s.038 0 .046.055a.136.136 0 010 .079.104.104 0 010 .063.102.102 0 01-.047.055l-.45.355a.088.088 0 000 .055v.07a.12.12 0 000 .072v.055l.552.472a.161.161 0 00.077 0 .153.153 0 00.086 0l1.165-.59h.078a.13.13 0 01.078 0l.855.575c.022.017.04.038.054.063a.234.234 0 010 .07v.481a.169.169 0 010 .095.179.179 0 01-.078.055l-.847.323a.156.156 0 00-.078.063l-.613.875a.152.152 0 000 .094v.528a.184.184 0 010 .087.21.21 0 01-.063.055l-1.142.599a.14.14 0 00-.054.04.24.24 0 000 .062l-.288 1.032a.347.347 0 01-.116.182.318.318 0 01-.288.039H5.19a.138.138 0 00-.055 0l-.35.354a.096.096 0 000 .08.136.136 0 000 .094c.011.028.03.053.055.07.03.008.062.008.093 0h2.246l.039.19.567.575H7.901l.606.016zM11.88 13.733v2.53a.242.242 0 010 .078.214.214 0 01-.055.063l-1.873 1.34a.3.3 0 00-.07.102l-.334 1.474-.109.504a.213.213 0 01-.047.079.236.236 0 01-.077 0 .426.426 0 00-.249.228c-.062.119-.078.103-.21.071l-.248-.055-.21-.055h.085c-.295-.055-.536-.418-.598-.52v-.047l-.14-.694-.295-1.182 2.914-5.129 1.414 1.08s.039 0 .047.055c.022.023.04.05.054.078z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M10.76 2.844h-.179a4.82 4.82 0 00-.676.048 8.6 8.6 0 00-2.385.622c.1.071-.07.134-.07.134l.272.536h1.46l.995.544.878-.513-.295-1.37zM15.33 5.145a.274.274 0 010 .079l-.047.07-.676.592a.138.138 0 01-.093 0 .215.215 0 01-.101 0l-.249-.158.56-.977.52.244a.211.211 0 01.062.056c.015.03.023.061.024.094zM17.739 6.752l-.241-.378a5.222 5.222 0 00-.707-1.119c-.233-.22-.296-.157-.311-.11a.173.173 0 01-.055.071l-1.204.97a.176.176 0 01-.109 0h-.738l-.497.503a.142.142 0 00-.04.056.176.176 0 000 .063.152.152 0 000 .063c.01.02.023.04.04.055l.497.512h3.295l.054-.04a.128.128 0 000-.055.256.256 0 000-.063v-.559l.016.031z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M10.512 2.167a9.237 9.237 0 00-5.328 1.691 9.438 9.438 0 00-3.42 4.474 9.58 9.58 0 00-.287 5.654 9.475 9.475 0 002.95 4.806l.855-1.505c-.431-.4-.812-.853-1.135-1.347a7.876 7.876 0 01-1.259-5.082c.015-.183.04-.365.078-.544a7.735 7.735 0 012.13-4.184 7.47 7.47 0 012.486-1.686l.132-.055a7.524 7.524 0 012.798-.536 7.051 7.051 0 012.222.347l.855-1.505a9.056 9.056 0 00-3.077-.528zm4.934 1.426l-.839 1.473c.272.165.532.349.777.552a7.775 7.775 0 012.59 4.171 7.86 7.86 0 01-.41 4.912 7.725 7.725 0 01-3.246 3.67 7.566 7.566 0 01-6.005.68 7.55 7.55 0 01-.591-.212c-.253-.097-.5-.21-.738-.339l-.855 1.474a9.215 9.215 0 007.078.944 9.345 9.345 0 005.662-4.407 9.572 9.572 0 00.931-7.176 9.44 9.44 0 00-4.346-5.742h-.008z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M18.7.794L17.414.042 4.25 23.16l1.286.753L18.7.794z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#FCECEA",
        stroke: "#F5C0B8"
      }), r.createElement("path", {
        d: "M16.767 17.49c.724 0 1.428-.089 1.962-.253v-1.093c-.383.143-1.128.239-1.86.239-2.905 0-4.744-1.764-4.744-4.546v-.014c0-2.734 1.839-4.641 4.484-4.641 2.598 0 4.307 1.62 4.307 4.088v.013c0 1.402-.444 2.304-1.135 2.304-.417 0-.656-.287-.656-.772V9.157h-1.38v.82h-.124c-.273-.608-.868-.97-1.6-.97-1.367 0-2.296 1.135-2.296 2.789v.014c0 1.73.943 2.884 2.365 2.884.793 0 1.353-.362 1.64-1.052h.123l.007.04c.158.636.78 1.033 1.62 1.033 1.655 0 2.687-1.367 2.687-3.534v-.014c0-3.008-2.242-5.072-5.517-5.072-3.418 0-5.776 2.324-5.776 5.694v.014c0 3.431 2.331 5.687 5.893 5.687zm-.342-4.053c-.718 0-1.149-.602-1.149-1.586v-.014c0-.991.431-1.586 1.156-1.586.724 0 1.182.608 1.182 1.586v.014c0 .977-.458 1.585-1.19 1.585z",
        fill: "#D02B20"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-4-9a4 4 0 108 0H8zm0-2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm8 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-5-5h2a3 3 0 016 0h2a5 5 0 10-10 0zm1-6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm8 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 216 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("g", {
        opacity: .84,
        clipPath: "url(#EmptyDocuments_svg__clip0_1142_57509)"
      }, r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M189.25 19.646a7.583 7.583 0 010 15.166h-43.333a7.583 7.583 0 010 15.167h23.833a7.583 7.583 0 010 15.167h-11.022c-5.28 0-9.561 3.395-9.561 7.583 0 1.956 1.063 3.782 3.19 5.48 2.017 1.608 4.824 1.817 7.064 3.096a7.583 7.583 0 01-3.754 14.174H65.75a7.583 7.583 0 010-15.166H23.5a7.583 7.583 0 110-15.167h43.333a7.583 7.583 0 100-15.167H39.75a7.583 7.583 0 110-15.166h43.333a7.583 7.583 0 010-15.167H189.25zm0 30.333a7.583 7.583 0 110 15.166 7.583 7.583 0 010-15.166z",
        fill: "#D9D8FF",
        fillOpacity: .8
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M132.561 19.646l10.077 73.496.906 7.374a4.334 4.334 0 01-3.773 4.829l-63.44 7.789a4.333 4.333 0 01-4.83-3.772l-9.767-79.547a2.166 2.166 0 011.91-2.417l5.262-.59 63.655-7.162zM73.162 26.33l4.97-.557-4.97.557z",
        fill: "#fff"
      }), r.createElement("path", {
        d: "M73.162 26.33l4.97-.557m54.429-6.127l10.077 73.496.906 7.374a4.334 4.334 0 01-3.773 4.829l-63.44 7.789a4.333 4.333 0 01-4.83-3.772l-9.767-79.547a2.166 2.166 0 011.91-2.417l5.262-.59 63.655-7.162z",
        stroke: "#7B79FF",
        strokeWidth: 2.5
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M129.818 24.27l9.122 66.608.82 6.682c.264 2.153-1.246 4.11-3.373 4.371l-56.812 6.976c-2.127.261-4.066-1.272-4.33-3.425l-8.83-71.908a2.167 2.167 0 011.887-2.415l7.028-.863",
        fill: "#F0F0FF"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M135.331 5.833H85.978a2.97 2.97 0 00-2.107.873A2.97 2.97 0 0083 8.813v82.333c0 .823.333 1.567.872 2.106a2.97 2.97 0 002.107.873h63.917a2.97 2.97 0 002.106-.873 2.97 2.97 0 00.873-2.106V23.367a2.98 2.98 0 00-.873-2.107L137.437 6.705a2.98 2.98 0 00-2.106-.872z",
        fill: "#fff",
        stroke: "#7B79FF",
        strokeWidth: 2.5
      }), r.createElement("path", {
        d: "M135.811 7.082v12.564a3.25 3.25 0 003.25 3.25h8.595M94.644 78.146h28.167m-28.167-55.25h28.167-28.167zm0 13h46.584-46.584zm0 14.083h46.584-46.584zm0 14.084h46.584-46.584z",
        stroke: "#7B79FF",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })), r.createElement("defs", null, r.createElement("clipPath", {
        id: "EmptyDocuments_svg__clip0_1142_57509"
      }, r.createElement("path", {
        fill: "#fff",
        d: "M0 0h216v120H0z"
      }))));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 192 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("g", {
        opacity: .88
      }, r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M160.28 53.026a3.89 3.89 0 00-.15-.281c-3.5-5.96-7.289-11.263-11.52-15.857h18.097c4.444 0 8.047 3.612 8.047 8.069 0 4.456-3.603 8.07-8.047 8.07h-6.427zm-8.492 16.139c-11.563 11.57-31.954 19.597-55.211 19.597-31.435 0-54.383-16.705-55.7-35.736H28.741c-4.444 0-8.047 3.613-8.047 8.07 0 4.456 3.603 8.069 8.047 8.069H40.44c5.604 0 10.147 3.612 10.147 8.069 0 2.524-1.66 4.846-4.98 6.964-.942.6-2.033.875-3.123 1.15-.33.082-.658.165-.982.257a8.07 8.07 0 00-5.861 7.767c0 4.457 3.603 8.07 8.048 8.07h95.425c4.445 0 8.048-3.613 8.048-8.07 0-4.456-3.603-8.069-8.048-8.069h44.838c4.445 0 8.048-3.612 8.048-8.07 0-4.456-3.603-8.068-8.048-8.068h-32.164zM68.056 20.749H8.048C3.603 20.75 0 24.362 0 28.82c0 4.456 3.603 8.069 8.048 8.069h37.314c4.606-6.844 12.5-12.478 22.694-16.139zM0 61.095c0-4.456 3.603-8.069 8.048-8.069s8.048 3.613 8.048 8.07c0 4.456-3.603 8.069-8.048 8.069S0 65.552 0 61.095z",
        fill: "#DBDBFA"
      }), r.createElement("path", {
        d: "M157.424 48.415l1.447 2.131",
        stroke: "#7B79FF",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), r.createElement("path", {
        d: "M154.195 58.894c-45.683-57.685-95.639-25.813-117.374.01-1.403 1.666-1.426 4.115-.15 5.881 47.31 65.454 96.71 29.043 117.705-.133 1.239-1.723 1.137-4.095-.181-5.758z",
        fill: "#fff"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M112.869 27.294c-9.141-2.486-18.085-2.558-26.571-.941-21.301 4.058-39.457 18.708-50.43 31.743-1.794 2.132-1.797 5.216-.205 7.419 11.917 16.487 24.03 26.65 35.888 32.099.79.363 1.58.705 2.367 1.026l1.206-2.208a57.244 57.244 0 01-2.529-1.09C61.228 90.12 49.426 80.29 37.689 64.05c-.961-1.329-.92-3.142.092-4.344C48.545 46.918 66.234 32.72 86.766 28.809c7.905-1.506 16.271-1.495 24.869.744l1.234-2.26zM84.593 99.259c7.096 1.397 13.98 1.156 20.536-.278 20.46-4.474 37.825-20.594 48.236-35.062.899-1.25.841-3.007-.145-4.252-10.729-13.547-21.653-22.062-32.352-26.854l1.202-2.2c11.025 4.98 22.209 13.738 33.11 27.502 1.649 2.082 1.794 5.069.214 7.264-10.583 14.709-28.415 31.383-49.731 36.044-7.116 1.556-14.608 1.77-22.324.132l1.254-2.296z",
        fill: "#7B79FF"
      }), r.createElement("path", {
        d: "M126.492 21.282c13.231 6.322 21.865 14.379 27.624 21.78M33.4 47.845c18.935-25.304 55.13-40.341 83.887-30.007",
        stroke: "#7B79FF",
        strokeWidth: 2.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), r.createElement("ellipse", {
        cx: 94.313,
        cy: 65.708,
        rx: 18.395,
        ry: 18.444,
        fill: "#F0F0FF"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M104.094 43.565a24.006 24.006 0 00-9.777-2.067c-13.334 0-24.144 10.839-24.144 24.208 0 8.429 4.296 15.851 10.813 20.186l1.203-2.204c-5.74-3.902-9.516-10.498-9.516-17.982 0-11.995 9.697-21.708 21.644-21.708 3.045 0 5.944.631 8.574 1.77l1.203-2.203zM91.283 87.202c.991.14 2.004.212 3.034.212 11.947 0 21.644-9.713 21.644-21.708a21.66 21.66 0 00-5.222-14.141l1.272-2.33a24.16 24.16 0 016.45 16.471c0 13.37-10.81 24.208-24.144 24.208-1.47 0-2.908-.132-4.305-.384l1.27-2.328z",
        fill: "#7B79FF"
      }), r.createElement("path", {
        d: "M116.062 54.18c0 4.406-3.561 7.972-7.947 7.972-4.387 0-7.948-3.566-7.948-7.972 0-4.406 3.561-7.972 7.948-7.972 4.386 0 7.947 3.566 7.947 7.972z",
        fill: "#fff",
        stroke: "#7B79FF",
        strokeWidth: 2.5
      }), r.createElement("path", {
        d: "M109.805 32.838c1.275-2.324 4.079-3.019 6.296-1.56 2.265 1.49 3.053 4.654 1.751 7.027l-31.287 57.05c-1.275 2.324-4.078 3.018-6.296 1.559-2.265-1.49-3.053-4.653-1.75-7.027l31.286-57.05z",
        fill: "#fff"
      }), r.createElement("rect", {
        width: 3.668,
        height: 134.376,
        rx: 1.834,
        transform: "matrix(.82817 .56048 -.47918 .87772 126.515 0)",
        fill: "#7B79FF"
      })));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 216 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("g", {
        opacity: .88
      }, r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M119 28a7 7 0 110 14h64a7 7 0 110 14h22a7 7 0 110 14h-19a7 7 0 100 14h6a7 7 0 110 14h-52a7.024 7.024 0 01-1.5-.161A7.024 7.024 0 01137 98H46a7 7 0 110-14H7a7 7 0 110-14h40a7 7 0 100-14H22a7 7 0 110-14h40a7 7 0 110-14h57zm90 56a7 7 0 110 14 7 7 0 010-14z",
        fill: "#D9D8FF",
        fillOpacity: .8
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M73.83 102.273l-8.621 1.422a4 4 0 01-4.518-3.404L49.557 21.069a4 4 0 013.404-4.518l78.231-10.994a4 4 0 014.518 3.404c.475 3.377 2.408 16.468 2.572 17.63",
        fill: "#fff"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M71.805 98.712l-3.696.526a3.618 3.618 0 01-4.096-3.085l-9.995-71.925a3.646 3.646 0 013.097-4.108l71.037-10.096a3.618 3.618 0 014.097 3.085l.859 6.18 9.205 66.599c.306 2.212-1.219 4.257-3.407 4.566a4.31 4.31 0 01-.071.01l-67.03 8.248z",
        fill: "#F0F0FF"
      }), r.createElement("path", {
        d: "M69.278 103.123l-4.07.572a4 4 0 01-4.517-3.404L49.557 21.069a4 4 0 013.404-4.518l78.231-10.994a4 4 0 014.518 3.404l.957 6.808M137.5 20.38l.5 3.12",
        stroke: "#7B79FF",
        strokeWidth: 2.5,
        strokeLinecap: "round"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M164.411 30.299L85.844 22.04a2.74 2.74 0 00-2.018.598 2.741 2.741 0 00-1.004 1.85l-8.363 79.561c-.079.755.155 1.471.598 2.018a2.74 2.74 0 001.85 1.004l78.567 8.258a2.739 2.739 0 002.018-.598 2.741 2.741 0 001.005-1.849l8.362-79.562a2.743 2.743 0 00-.598-2.018 2.74 2.74 0 00-1.85-1.004z",
        fill: "#fff",
        stroke: "#7B79FF",
        strokeWidth: 2.5
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M92.99 30.585l62.655 6.585a3 3 0 012.67 3.297l-5.54 52.71a3 3 0 01-3.297 2.67L86.823 89.26a3 3 0 01-2.67-3.297l5.54-52.71a3 3 0 013.297-2.67z",
        fill: "#fff"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M92.74 73.878l9.798-6.608a4 4 0 015.168.594l7.173 7.723a1 1 0 001.362.096l15.34-12.43a4 4 0 015.878.936l9.98 15.438 1.434 2.392-.687 8.124a1 1 0 01-1.106.91l-56.963-6.329a1 1 0 01-.886-1.085l.755-8.199 2.755-1.562z",
        fill: "#F0F0FF"
      }), r.createElement("path", {
        clipRule: "evenodd",
        d: "M155.514 38.413L92.86 31.828c-.481-.05-.937.098-1.285.38a1.745 1.745 0 00-.639 1.177l-5.54 52.71c-.05.48.099.936.38 1.284.282.348.697.589 1.178.64l62.655 6.585a1.747 1.747 0 001.923-1.558l5.54-52.71a1.75 1.75 0 00-1.558-1.923z",
        stroke: "#7B79FF",
        strokeWidth: 2.5
      }), r.createElement("path", {
        d: "M104.405 55.917a6 6 0 101.254-11.934 6 6 0 00-1.254 11.934z",
        fill: "#F0F0FF",
        stroke: "#7B79FF",
        strokeWidth: 2.5
      }), r.createElement("path", {
        d: "M90.729 75.425l11.809-8.155a4 4 0 015.168.594l7.173 7.723a1 1 0 001.362.096l15.34-12.43a4 4 0 015.878.936l11.064 17.556",
        stroke: "#7B79FF",
        strokeWidth: 2.5,
        strokeLinecap: "round"
      })));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#F6ECFC",
        stroke: "#E0C1F4"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.167 7a1.167 1.167 0 100 2.333 1.167 1.167 0 000-2.333zm0 4.03a1.167 1.167 0 100 2.334 1.167 1.167 0 000-2.334zM9 16.23a1.167 1.167 0 112.333 0 1.167 1.167 0 01-2.333 0zm4.005-9.02a.4.4 0 00-.4.4v1.11c0 .22.18.4.4.4H22.6a.4.4 0 00.4-.4V7.61a.4.4 0 00-.4-.4h-9.594zm-.399 4.432a.4.4 0 01.4-.4H22.6c.22 0 .4.18.4.4v1.11a.4.4 0 01-.4.4h-9.594a.4.4 0 01-.4-.4v-1.11zm.4 3.63a.4.4 0 00-.4.4v1.11c0 .22.18.4.4.4H22.6a.4.4 0 00.4-.4v-1.11a.4.4 0 00-.4-.4h-9.594z",
        fill: "#9736E8"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 2.8A.8.8 0 01.8 2h22.4a.8.8 0 01.8.8v2.71a1 1 0 01-1 1H1a1 1 0 01-1-1V2.8z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M1.922 7.991C.197 6.675 0 6.252 0 5.289h23.953c.305 1.363-1.594 2.506-2.297 3.125-1.953 1.363-6.253 4.36-7.828 5.45-1.575 1.09-3.031.455-3.562 0-2.063-1.41-6.62-4.557-8.344-5.873zM22.8 18H1.2c-.663 0-1.2.471-1.2 1.053v1.894C0 21.529.537 22 1.2 22h21.6c.663 0 1.2-.471 1.2-1.053v-1.894c0-.582-.537-1.053-1.2-1.053z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M0 9.555v10.972h24V9.554c-2.633 1.95-8.367 6.113-9.96 7.166-1.595 1.052-3.352.438-4.032 0L0 9.555z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M6.17 18a3 3 0 015.66 0H22v2H11.83a3 3 0 01-5.66 0H2v-2h4.17zm6-7a3 3 0 015.66 0H22v2h-4.17a3 3 0 01-5.66 0H2v-2h10.17zm-6-7a3.001 3.001 0 015.66 0H22v2H11.83a3 3 0 01-5.66 0H2V4h4.17z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm1.154 18.456h-2.308V16.15h2.308v2.307zm-.23-3.687h-1.847l-.346-9.23h2.538l-.346 9.23z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M11.987 23.036v-.964H1.876V1.876h10.111V0H0v24h11.987v-.964z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M8 11.2c0-.11.09-.2.2-.2h11.973l-5.445-5.445a.2.2 0 010-.283l1.13-1.13a.2.2 0 01.283 0l7.718 7.717a.2.2 0 010 .282L16.14 19.86a.2.2 0 01-.282 0l-1.13-1.13a.2.2 0 010-.284L20.172 13H8.2a.2.2 0 01-.2-.2v-1.6z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M1.371 1.371h2.743V0H0v4.114h1.371V1.371zM7.886 1.371h2.743v2.743H12V0H7.886v1.371zM0 12h4.114v-1.372H1.371V7.885H0v4.114zM10.629 10.628H7.886v1.371H12V7.885h-1.371v2.743z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M16.235 2.824a1.412 1.412 0 010-2.824h6.353C23.368 0 24 .633 24 1.412v6.353a1.412 1.412 0 01-2.823 0V4.82l-8.179 8.178a1.412 1.412 0 01-1.996-1.996l8.178-8.178h-2.945zm4.942 10.588a1.412 1.412 0 012.823 0v9.176c0 .78-.632 1.412-1.412 1.412H1.412C.632 24 0 23.368 0 22.588V1.412C0 .632.632 0 1.412 0h9.176a1.412 1.412 0 010 2.824H2.824v18.353h18.353v-7.765z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M15.2 12a3.2 3.2 0 11-6.399 0 3.2 3.2 0 016.4 0z",
        fill: "#212134"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.78 6.103c1.923 1.243 3.64 2.981 4.963 5.027a1.61 1.61 0 01.005 1.738c-1.318 2.063-3.031 3.807-4.954 5.046-2.12 1.364-4.475 2.086-6.81 2.086-2.388 0-4.683-.7-6.816-2.082-1.894-1.225-3.593-2.966-4.914-5.032a1.596 1.596 0 01.032-1.777C1.89 8.811 3.734 7.027 5.77 5.805 7.767 4.608 9.858 4 11.984 4c2.317 0 4.667.728 6.795 2.103zm-9.446 9.888a4.8 4.8 0 105.334-7.982 4.8 4.8 0 00-5.334 7.982z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M4.048 6.875L2.103 4.93a1 1 0 111.414-1.415l16.966 16.966a1 1 0 11-1.414 1.415l-2.686-2.686a12.247 12.247 0 01-4.383.788c-3.573 0-6.559-1.425-8.962-3.783a15.842 15.842 0 01-2.116-2.568 11.096 11.096 0 01-.711-1.211 1.145 1.145 0 010-.875c.124-.258.36-.68.711-1.211.58-.876 1.283-1.75 2.116-2.569.326-.32.663-.622 1.01-.906zm10.539 10.539l-1.551-1.551a4.005 4.005 0 01-4.9-4.9L6.584 9.411a6 6 0 008.002 8.002zM7.617 4.787A12.248 12.248 0 0112 3.998c3.572 0 6.559 1.426 8.961 3.783a15.845 15.845 0 012.117 2.569c.351.532.587.954.711 1.211.116.242.115.636 0 .875-.124.257-.36.68-.711 1.211-.58.876-1.283 1.75-2.117 2.568-.325.32-.662.623-1.01.907l-2.536-2.537a6 6 0 00-8.002-8.002L7.617 4.787zm3.347 3.347A4.005 4.005 0 0116 11.998c0 .359-.047.706-.136 1.037l-4.9-4.901z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.143 24zm1.732-.146V15.47h2.796l.532-3.47h-3.328V9.749c0-.949.464-1.875 1.956-1.875h1.514V4.921s-1.374-.235-2.687-.235c-2.74 0-4.533 1.66-4.533 4.67V12H7.078v3.47h3.047v8.384C4.388 22.954 0 17.99 0 12 0 5.373 5.373 0 12 0s12 5.373 12 12c0 5.99-4.388 10.954-10.125 11.854z",
        fill: "#1977F3"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M21 2C6 2 4 16 3 22h1.998c.666-3.333 2.333-5.166 5.002-5.5 4-.5 7-4 8-7l-1.5-1 1-1c1-1 2.004-2.5 3.5-5.5z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 4a4 4 0 014-4h24a4 4 0 014 4v24a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
        fill: "#9736E8"
      }), r.createElement("path", {
        d: "M18.037 11.774a28.578 28.578 0 00-2.948 2.706c-1.995 2.109-3.55 4.093-4.761 6.06-.289.469-.574.945-.855 1.418a9.074 9.074 0 00-.463 1.536c-.074.37.275.68.577.395.312-.299.587-.64.851-.985.467-.608.906-1.237 1.342-1.867 3.37.242 7.27-2.048 8.933-4.857a.196.196 0 00.017-.167.183.183 0 00-.114-.118c-.809-.27-1.798-.44-2.207-.462-.017 0-.034-.014-.037-.035a.039.039 0 01.024-.043c1.113-.58 1.924-.647 2.877-.505.07.01.134-.046.16-.114.095-.217.356-.87.537-1.404a.201.201 0 00-.087-.239c-.71-.384-1.656-.643-2.035-.682-.017 0-.03-.018-.034-.036a.039.039 0 01.024-.043c1.1-.483 1.485-.497 2.364-.302.087.018.17-.05.19-.142.433-1.714.574-3.197.608-3.68a.21.21 0 00-.057-.157.177.177 0 00-.148-.05c-2.444.356-4.403.865-6.093 1.55-.057.022-.11.072-.11.136.144.551-.242 1.209-.845 1.703a.042.042 0 01-.044.018.046.046 0 01-.027-.043c.004-.046.158-.665.067-1.116-.013-.064-.033-.125-.084-.16a.173.173 0 00-.17-.014c-7.924 3.811-5.922 10.098-5.922 10.098.01.004.02.004.03.007.895-1.86 1.904-3.232 3.49-5.035 1.178-1.337 2.331-2.425 3.525-3.325.75-.565 2.448-1.738 3.51-2.144a.285.285 0 01.105-.021c.097 0 .177.064.2.16a.264.264 0 01-.046.228l-2.344 1.731z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.39.749l6.915 7.377A2.59 2.59 0 0124 9.877v19.638c0 1.381-1.042 2.493-2.337 2.493H2.337C1.042 32.008 0 30.896 0 29.515V2.5C0 1.827.253 1.22.695.75 1.137.277 1.705.008 2.337.008h12.41c.6 0 1.2.27 1.643.74zm.473 7.983h5.116L15.82 2.197V7.62c0 .607.474 1.112 1.042 1.112zM2.337 30.559h19.326c.537 0 .98-.471.98-1.044V10.18h-5.78c-1.326 0-2.4-1.145-2.4-2.56V1.456H2.337a.949.949 0 00-.695.303c-.19.203-.284.472-.284.741v27.015c0 .573.442 1.044.979 1.044zm3.358-5.248h12.442c.379 0 .695.326.726.718 0 .392-.316.718-.694.718H5.695c-.38 0-.695-.326-.695-.718 0-.392.316-.718.695-.718zm12.442-5.287H5.695c-.38 0-.695.327-.695.718 0 .392.316.718.695.718h12.474c.378 0 .694-.326.694-.718 0-.391-.347-.718-.726-.718zM5.695 14.738h12.442c.379 0 .726.326.726.718 0 .391-.316.718-.694.718H5.695c-.38 0-.695-.327-.695-.718 0-.392.316-.718.695-.718z",
        fill: "#C0C0CF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.305 8.118L16.39.74C15.947.27 15.347 0 14.747 0H2.337c-.632 0-1.2.27-1.642.741A2.529 2.529 0 000 2.493v27.014C0 30.888 1.042 32 2.337 32h19.326C22.958 32 24 30.888 24 29.507V9.87c0-.64-.253-1.28-.695-1.751zm-1.326.606h-5.116c-.568 0-1.042-.505-1.042-1.111V2.189l6.158 6.535zm-.316 21.828H2.337c-.537 0-.98-.472-.98-1.045V2.493c0-.27.096-.54.285-.741a.949.949 0 01.695-.304h12.126v6.165c0 1.414 1.074 2.56 2.4 2.56h5.78v19.334c0 .573-.443 1.045-.98 1.045zM10.477 19.734L6.512 23.7a.73.73 0 000 1.024.73.73 0 001.023 0l3.965-3.965 3.965 3.965a.73.73 0 001.023 0 .73.73 0 000-1.024l-3.965-3.965 4.2-4.2a.73.73 0 000-1.023c-.28-.279-.768-.255-1.047.024L11.5 18.71l-4.176-4.176c-.28-.28-.768-.303-1.047-.024a.73.73 0 000 1.024l4.2 4.2z",
        fill: "#D02B20"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M23.305 8.126L16.39.749c-.443-.472-1.043-.741-1.643-.741H2.337c-.632 0-1.2.27-1.642.74A2.529 2.529 0 000 2.5v27.015c0 1.381 1.042 2.493 2.337 2.493h19.326c1.295 0 2.337-1.112 2.337-2.493V9.877c0-.64-.253-1.28-.695-1.751zm-1.326.606h-5.116c-.568 0-1.042-.505-1.042-1.112V2.197l6.158 6.535zm-.316 21.827H2.337c-.537 0-.98-.471-.98-1.044V2.5c0-.269.096-.538.285-.74a.949.949 0 01.695-.304h12.126V7.62c0 1.415 1.074 2.56 2.4 2.56h5.78v19.335c0 .573-.443 1.044-.98 1.044z",
        fill: "#D9822F"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.964 20.095c.344.252.781.522 1.312.811a16.714 16.714 0 011.827-.1c1.53 0 2.451.236 2.764.709.166.212.177.463.031.753 0 .01-.005.02-.016.029l-.03.029v.014c-.063.367-.433.55-1.11.55-.5 0-1.098-.096-1.795-.29a11.908 11.908 0 01-2.03-.767c-2.3.232-4.341.633-6.121 1.202-1.593 2.53-2.852 3.795-3.779 3.795a.965.965 0 01-.437-.102l-.375-.174a1.668 1.668 0 00-.093-.072c-.105-.096-.136-.27-.094-.521.094-.386.385-.828.874-1.325.49-.498 1.177-.963 2.061-1.398.146-.087.266-.058.36.087.02.02.03.039.03.058a34.703 34.703 0 001.672-2.853c.707-1.313 1.249-2.578 1.623-3.794a10.952 10.952 0 01-.476-2.31c-.067-.748-.034-1.364.102-1.847.114-.386.333-.579.655-.579h.344c.24 0 .422.072.547.217.187.203.234.531.14.985a.307.307 0 01-.062.116.35.35 0 01.015.116v.434c-.02 1.188-.093 2.115-.218 2.78.572 1.584 1.332 2.733 2.28 3.447zM4.97 26.047c.542-.232 1.255-.995 2.14-2.289-.531.387-.987.792-1.367 1.217-.38.425-.637.782-.773 1.072zm6.183-11.412c-.135-.868-.125-1.506.032-1.911v-.03c.01-.009.015-.019.015-.028a.798.798 0 01.203.521c0 .01.005.024.016.044 0 .01.005.019.015.029a.317.317 0 00-.062.116c-.073.386-.11.593-.11.622l-.109.637zm-1.904 7.66a24.288 24.288 0 014.434-1.173 2.398 2.398 0 01-.203-.137 2.761 2.761 0 01-.25-.196c-.79-.647-1.452-1.496-1.983-2.549-.28.83-.713 1.782-1.296 2.854-.312.54-.546.94-.702 1.201zm7.9-.58c1.208 0 1.937.117 2.187.349.02.019.031.033.031.043-.042.01-.135.014-.281.014-.5 0-1.145-.135-1.936-.405z",
        fill: "#D9822F"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 4a2 2 0 012-2h20a2 2 0 110 4H2a2 2 0 01-2-2zm4 8a2 2 0 012-2h12a2 2 0 110 4H6a2 2 0 01-2-2zm6 6a2 2 0 100 4h4a2 2 0 100-4h-4z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12.414 5H21a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h7.414l2 2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M18.901 10a3 3 0 004.075 1.113 3.5 3.5 0 01-1.975 3.55V21h-6v-2a3 3 0 00-5.996-.176L9 19v2H3v-6.336a3.5 3.5 0 01-1.979-3.553A2.999 2.999 0 005.098 10h13.803zm-1.865-7a3.5 3.5 0 004.446 2.86 3.5 3.5 0 01-3.29 3.135L18 9H6a3.5 3.5 0 01-3.482-3.14A3.5 3.5 0 006.964 3h10.072z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M15 2a4 4 0 013.464 6.001L23 8v2h-2v10a1 1 0 01-1 1H4a1 1 0 01-1-1V10H1V8l4.536.001A4 4 0 0112 3.355 3.983 3.983 0 0115 2zm-2 8h-2v10h2V10zM9 4a2 2 0 00-.15 3.995L9 8h2V6a2 2 0 00-1.697-1.977l-.154-.018L9 4zm6 0a2 2 0 00-1.995 1.85L13 6v2h2a2 2 0 001.995-1.85L17 6a2 2 0 00-2-2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 0C5.373 0 0 5.501 0 12.288c0 5.43 3.438 10.035 8.206 11.66.6.114.82-.266.82-.59 0-.294-.01-1.262-.016-2.289-3.338.744-4.043-1.45-4.043-1.45-.546-1.42-1.332-1.797-1.332-1.797-1.089-.763.082-.747.082-.747 1.205.086 1.84 1.266 1.84 1.266 1.07 1.878 2.807 1.335 3.491 1.021.108-.794.42-1.336.762-1.643-2.665-.31-5.467-1.364-5.467-6.073 0-1.341.469-2.437 1.236-3.298-.124-.31-.535-1.56.117-3.252 0 0 1.007-.33 3.3 1.26A11.25 11.25 0 0112 5.942c1.02.005 2.047.141 3.006.414 2.29-1.59 3.297-1.26 3.297-1.26.653 1.693.242 2.943.118 3.252.77.86 1.235 1.957 1.235 3.298 0 4.72-2.808 5.76-5.48 6.063.43.382.814 1.13.814 2.276 0 1.644-.014 2.967-.014 3.372 0 .327.216.71.825.59C20.566 22.32 24 17.715 24 12.288 24 5.501 18.627 0 12 0z",
        fill: "#161614"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 4a4 4 0 014-4h24a4 4 0 014 4v24a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
        fill: "#AC73E6"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.027 13.839c-3.19-.836-6.305-1.064-10.18-.608-1.215.152-1.063 1.975.076 2.203.304.836.456 2.355.912 3.267.987 2.279 5.622 1.975 7.369.835 1.14-.683 1.443-2.279 1.9-3.494.227-.684 1.595-.684 1.822 0 .38 1.215.76 2.81 1.9 3.494 1.747 1.14 6.381 1.444 7.369-.835.456-.912.607-2.431.911-3.267 1.14-.228 1.216-2.051.076-2.203-3.874-.456-6.989-.228-10.18.608-.455.075-1.519.075-1.975 0z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M13 21h5v2H6v-2h5v-1.05a10.001 10.001 0 01-7.684-4.988l1.737-.992A8 8 0 1015.97 3.053l.992-1.737A9.996 9.996 0 0122 10c0 5.185-3.947 9.449-9 9.95V21zm-1-4a7 7 0 110-14 7 7 0 010 14z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.76 6.801a1.435 1.435 0 00.797 0l4.31 7.45a1.418 1.418 0 00-.401.696H7.85a1.427 1.427 0 00-.401-.693L11.76 6.8zm-.63-.378l.042.04-4.312 7.453a1.374 1.374 0 00-.056-.015v-3.802A1.42 1.42 0 007.83 8.324l3.3-1.901zm2.396-.583a1.428 1.428 0 10-2.737-.002L7.494 7.736a1.431 1.431 0 00-2.273.268 1.425 1.425 0 00.904 2.098V13.9a1.426 1.426 0 101.37 2.368l3.293 1.897a1.425 1.425 0 001.37 1.828 1.427 1.427 0 001.355-1.873l3.274-1.887a1.431 1.431 0 002.304-.236 1.419 1.419 0 00-.9-2.097v-3.797a1.426 1.426 0 10-1.371-2.365L13.526 5.84zm-.381.622l.038-.038 3.302 1.903a1.42 1.42 0 001.027 1.772V13.9l-.055.015-4.312-7.453zm3.348 9.256l-3.28 1.89a1.425 1.425 0 00-1.055-.465c-.404 0-.77.167-1.029.436l-3.296-1.9a1.41 1.41 0 00.015-.055h8.619l.026.094z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M9.33 11.5h2.17A4.5 4.5 0 0116 16H8.999L9 17h8v-1a5.579 5.579 0 00-.886-3H19a5 5 0 014.516 2.851C21.151 18.972 17.322 21 13 21c-2.761 0-5.1-.59-7-1.625v-9.304A6.967 6.967 0 019.33 11.5zM4 9a1 1 0 01.993.883L5 10v9a1 1 0 01-1 1H2a1 1 0 01-1-1v-9a1 1 0 011-1h2zm9.646-5.425L14 3.93l.354-.354a2.5 2.5 0 113.535 3.536L14 11l-3.89-3.89a2.5 2.5 0 113.536-3.535z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M7.784 14l.42-4H4V8h4.415l.525-5h2.011l-.525 5h3.989l.525-5h2.011l-.525 5H20v2h-3.784l-.42 4H20v2h-4.415l-.525 5h-2.011l.525-5H9.585l-.525 5H7.049l.525-5H4v-2h3.784zm2.011 0h3.99l.42-4h-3.99l-.42 4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M4 12h3a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2v-7C2 6.477 6.477 2 12 2s10 4.477 10 10v7a2 2 0 01-2 2h-3a2 2 0 01-2-2v-5a2 2 0 012-2h3a8 8 0 00-16 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M20 20a1 1 0 01-1 1H5a1 1 0 01-1-1v-9H1l10.327-9.388a1 1 0 011.346 0L23 11h-3v9z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M5 5h14v1.53H5V5zm0 11.47h14V18H5v-1.53zm6.222-3.823H19v1.53h-7.778v-1.53zm0-3.823H19v1.529h-7.778v-1.53zM5 11.5l3.111-2.676v5.353L5 11.5z",
        fill: "#000"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M5 5h14v1.53H5V5zm0 11.47h14V18H5v-1.53zm6.222-3.823H19v1.53h-7.778v-1.53zm0-3.823H19v1.529h-7.778v-1.53zM8.112 11.5L5 14.177V8.824L8.111 11.5z",
        fill: "#000"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 4.92a1.56 1.56 0 110 3.12 1.56 1.56 0 010-3.12zm3.84 13.06a.5.5 0 01-.5.5h-6.2a.5.5 0 01-.5-.5v-.92a.5.5 0 01.5-.5h2.14v-5.28H9.86a.5.5 0 01-.5-.5v-.92a.5.5 0 01.5-.5h2.84a.5.5 0 01.5.5v6.7h2.14a.5.5 0 01.5.5v.92z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 4a4 4 0 014-4h24a4 4 0 014 4v24a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
        fill: "#4945FF"
      }), r.createElement("path", {
        d: "M15.733 8c.343 0 .678.108.963.31.285.202.507.49.639.826.13.337.165.707.098 1.064a1.879 1.879 0 01-.474.942 1.705 1.705 0 01-.887.504 1.64 1.64 0 01-1.002-.105 1.76 1.76 0 01-.778-.678A1.924 1.924 0 0114 9.841a1.9 1.9 0 01.508-1.302c.325-.345.766-.539 1.225-.539zM20 24h-8v-2.265h2.933v-6.23H12.8v-2.266h4.267v8.495H20V24z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.4 6h-5.6v1.6h1.693l-2.253 8.8H8V18h5.6v-1.6h-1.76l2.253-8.8H16.4V6z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#EAF5FF",
        stroke: "#B8E1FF"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.243 11.907v.157c.835.093 1.287.516 1.287 1.223V14.5c0 .693.236.959.855.959h.216V16.5h-.364c-1.459 0-2.078-.56-2.078-1.857v-.973c0-.722-.314-.992-1.159-1.002v-1.366c.84-.005 1.16-.275 1.16-1.002v-.968c0-1.282.618-1.832 2.077-1.832h.364v1.041h-.216c-.624 0-.855.266-.855.958v1.184c0 .713-.452 1.135-1.287 1.224zm15.804.181v-.157c-.835-.088-1.287-.51-1.287-1.223V9.495c0-.693-.236-.954-.855-.954h-.216V7.5h.363c1.454 0 2.073.56 2.073 1.852v.973c0 .722.32.997 1.165 1.002v1.366c-.845.005-1.165.28-1.165 1.002v.973c0 1.282-.613 1.832-2.073 1.832h-.363v-1.046h.216c.619 0 .855-.26.855-.954v-1.188c0-.708.452-1.13 1.287-1.224zM13.15 13a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2z",
        fill: "#0C75AF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M17 14h-4.34a6 6 0 110-4H23v4h-2v4h-4v-4zM7 14a2 2 0 100-4 2 2 0 000 4z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.3.6a.9.9 0 100 1.8h15.311a.9.9 0 100-1.8H4.301zm17.1 3.7A1.6 1.6 0 0123 5.9v15.5a1.6 1.6 0 01-1.6 1.6H2.6A1.601 1.601 0 011 21.4V8 5.915C1 5.03 1.716 4.3 2.6 4.3h18.8zM5.032 19.18h14.336l-3.136-3.205-1.792 1.831-4.032-4.12-5.376 5.494zm13.44-8.697c0 1.282-.985 2.289-2.24 2.289-1.254 0-2.24-1.007-2.24-2.29 0-1.281.986-2.288 2.24-2.288 1.255 0 2.24 1.007 2.24 2.289z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.1 5a.573.573 0 000 1.145h9.744a.573.573 0 000-1.145H7.1zm10.3 2.354a1.6 1.6 0 011.6 1.6v8.7a1.6 1.6 0 01-1.6 1.6H6.6a1.6 1.6 0 01-1.6-1.6V9.71v-.746c0-.884.716-1.609 1.6-1.609h10.8zm-9.834 9.47h9.123l-1.996-2.04-1.14 1.165-2.566-2.622-3.421 3.496zm7.127-4.078c-.798 0-1.425-.641-1.425-1.457 0-.816.627-1.457 1.425-1.457.799 0 1.426.641 1.426 1.457 0 .816-.627 1.457-1.426 1.457z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M4.8.2c0-.11.09-.2.2-.2h18.8c.11 0 .2.09.2.2v4.4a.2.2 0 01-.2.2H5a.2.2 0 01-.2-.2V.2zM0 9.8c0-.11.09-.2.2-.2H19c.11 0 .2.09.2.2v4.4a.2.2 0 01-.2.2H.2a.2.2 0 01-.2-.2V9.8zM5 19.2a.2.2 0 00-.2.2v4.4c0 .11.09.2.2.2h18.8a.2.2 0 00.2-.2v-4.4a.2.2 0 00-.2-.2H5z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.182 0A2.182 2.182 0 000 2.182v19.636C0 23.023.977 24 2.182 24h19.636A2.182 2.182 0 0024 21.818V2.182A2.182 2.182 0 0021.818 0H2.182zm9.354 11.987h7.539c.314 0 .55.209.55.549v6.539c0 .34-.236.55-.55.55h-7.539c-.34 0-.55-.236-.55-.55v-6.539c0-.34.236-.55.55-.55zm-6.638-2.27h14.177c.314 0 .549-.209.549-.549v-4.27c0-.34-.21-.549-.55-.549H4.899c-.313 0-.549.21-.549.55v4.269c0 .34.236.55.55.55zm3.27 9.907h-3.27a.536.536 0 01-.549-.55v-6.538c0-.34.236-.55.55-.55h3.269c.34 0 .55.21.55.55v6.539c0 .34-.236.55-.55.55z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M11 18H7.941c-.297-1.273-1.637-2.314-2.187-3a8 8 0 1112.49.002c-.55.685-1.888 1.726-2.185 2.998H13v-5h-2v5zm5 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1h8z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M21.415 1.344a6.137 6.137 0 00-8.525.838L11.095 4.33a1.53 1.53 0 102.35 1.963l1.794-2.148a3.054 3.054 0 014.365-.324 3.117 3.117 0 01.255 4.301l-3.73 4.467-.035.038a3.048 3.048 0 01-4.53.078 1.531 1.531 0 00-2.241 2.086 6.114 6.114 0 009.159-.245l3.721-4.454a6.289 6.289 0 001.418-4.62 6.01 6.01 0 00-2.206-4.128z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M10.399 17.884l-1.604 1.92a3.118 3.118 0 01-4.278.513 3.052 3.052 0 01-.457-4.353l3.795-4.542.028-.031a3.042 3.042 0 014.584-.022 1.529 1.529 0 001.794.37c.197-.094.37-.228.51-.395l.018-.022a1.51 1.51 0 00-.025-1.977 6.11 6.11 0 00-9.27.126l-3.784 4.53a6.137 6.137 0 00.692 8.539 6.01 6.01 0 004.454 1.437 6.289 6.289 0 004.294-2.217l1.598-1.913a1.53 1.53 0 00-2.35-1.963z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M17.756 5.748a3.416 3.416 0 00-4.747.467L12.01 7.41a.852.852 0 001.308 1.092l1-1.195a1.7 1.7 0 012.43-.18 1.735 1.735 0 01.141 2.394l-2.077 2.486-.019.022a1.697 1.697 0 01-2.522.043.852.852 0 00-1.248 1.162 3.405 3.405 0 005.1-.137l2.071-2.48a3.502 3.502 0 00.79-2.572 3.345 3.345 0 00-1.228-2.298z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M11.622 14.956l-.893 1.069a1.735 1.735 0 01-2.381.286 1.7 1.7 0 01-.255-2.423l2.113-2.529.016-.017a1.692 1.692 0 012.552-.012.852.852 0 00.999.205.841.841 0 00.284-.22l.01-.012a.84.84 0 00-.014-1.1 3.4 3.4 0 00-5.16.07l-2.108 2.522a3.417 3.417 0 00.385 4.754 3.346 3.346 0 002.48.8 3.501 3.501 0 002.39-1.234l.89-1.066a.852.852 0 10-1.308-1.093z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.057 18c.552 0 1 .451 1 .997v4.006a1 1 0 01-.941.995l-.059.002c-.552 0-1-.451-1-.997v-4.006a1 1 0 01.941-.995l.06-.002zm-3.06-.736l.055.03c.478.276.64.89.367 1.364l-2.002 3.468a1 1 0 01-1.31.394l-.055-.03a1.002 1.002 0 01-.368-1.363l2.003-3.469a1 1 0 011.31-.394zm7.42.394l2.002 3.468a1 1 0 01-.314 1.331l-.053.033a1.002 1.002 0 01-1.365-.363l-2.003-3.469a1 1 0 01.314-1.33l.054-.034a1.002 1.002 0 011.364.364zm-9.548-2.66l.033.054c.276.478.11 1.091-.364 1.364L3.07 18.42a1 1 0 01-1.331-.314l-.033-.053a1.001 1.001 0 01.364-1.365l3.468-2.003a1 1 0 011.33.314zm11.79-.313l3.468 2.002a1 1 0 01.393 1.31l-.03.055c-.276.478-.89.64-1.363.367l-3.469-2.003a1 1 0 01-.394-1.309l.03-.055c.276-.479.89-.64 1.364-.367zm4.344-3.628a1 1 0 01.995.941l.002.06c0 .551-.451 1-.997 1h-4.006a1 1 0 01-.995-.942L18 12.057c0-.552.451-1 .997-1h4.006zm-18 0a1 1 0 01.995.941l.002.06c0 .551-.451 1-.998 1H.998a1 1 0 01-.996-.942L0 12.057c0-.552.451-1 .998-1h4.004zm17.454-5.059l.033.054c.277.478.11 1.091-.363 1.365l-3.469 2.002a1 1 0 01-1.33-.314l-.034-.053a1.002 1.002 0 01.364-1.365l3.468-2.003a1 1 0 011.331.314zM3.07 5.684l3.468 2.003a1 1 0 01.394 1.31l-.03.055c-.276.478-.89.64-1.364.367L2.07 7.417a1 1 0 01-.394-1.31l.03-.055c.276-.479.89-.64 1.364-.368zm14.926-4.008l.056.03c.478.276.64.89.367 1.364l-2.003 3.468a1 1 0 01-1.309.394l-.055-.03a1.002 1.002 0 01-.367-1.364l2.002-3.468a1 1 0 011.31-.394zm-10.58.394L9.42 5.538a1 1 0 01-.314 1.33l-.053.034a1.002 1.002 0 01-1.365-.364L5.684 3.07a1 1 0 01.314-1.331l.054-.033a1.002 1.002 0 011.365.364zM12.058 0c.552 0 1 .451 1 .998v4.004a1 1 0 01-.941.996L12.057 6c-.552 0-1-.451-1-.998V.998a1 1 0 01.941-.996l.06-.002z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M19 10h1a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V11a1 1 0 011-1h1V9a7 7 0 0114 0v1zm-2 0V9A5 5 0 007 9v1h10zm-6 4v4h2v-4h-2z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M15.224 15.508l-2.213 4.65a.6.6 0 01-.977.155l-3.542-3.739a.6.6 0 00-.357-.182l-5.107-.668a.6.6 0 01-.449-.881l2.462-4.524a.6.6 0 00.062-.396L4.16 4.86a.6.6 0 01.7-.7l5.063.943a.6.6 0 00.396-.062l4.524-2.462a.6.6 0 01.881.45l.668 5.106a.6.6 0 00.182.357l3.739 3.542a.601.601 0 01-.155.977l-4.65 2.213a.6.6 0 00-.284.284zm.797 1.927l1.414-1.414 4.243 4.242-1.415 1.415-4.242-4.243z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 .8A.8.8 0 01.8 0h22.4a.8.8 0 01.8.8v2.71a1 1 0 01-1 1H1a1 1 0 01-1-1V.8z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M1.922 5.991C.197 4.675 0 4.252 0 3.289h23.953c.305 1.363-1.594 2.506-2.297 3.125-1.953 1.363-6.253 4.36-7.828 5.45-1.575 1.09-3.031.455-3.562 0-2.063-1.41-6.62-4.557-8.344-5.873zM22.8 16H1.2c-.663 0-1.2.471-1.2 1.053v1.894C0 19.529.537 20 1.2 20h21.6c.663 0 1.2-.471 1.2-1.053v-1.894c0-.582-.537-1.053-1.2-1.053z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M0 7.555v10.972h24V7.554c-2.633 1.95-8.367 6.113-9.96 7.165-1.595 1.053-3.352.439-4.032 0L0 7.555z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.4 14.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM3.6 14.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 22.8a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 6a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M6.24 11.28H18v1.44H6.24v-1.44z",
        fill: "#212134"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.6 22.8a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM3.6 6a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M18.328 13.863L6.49 19.765l-.652-1.307 11.838-5.902.652 1.307zM18.358 10.078L6.398 4.115l-.646 1.294 11.961 5.963.645-1.294z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M18.323 18.83L6.252 12.813l-.643 1.29 12.071 6.019.643-1.29zM18.136 5.228L6.207 11.176l-.653-1.311 11.928-5.948.654 1.311z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M17.76 11.28H6v1.44h11.76v-1.44z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M18.129 10.699L9.782 4.523l-.86 1.162 8.347 6.177.86-1.163zM18.101 13.354L9.755 19.53l-.864-1.167 8.347-6.176.863 1.167z",
        fill: "#212134"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.4 14.399a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM3.6 14.399a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM7.2 22.8a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2zM7.2 6a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8zm0 1.2a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.6 14.132a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M6.24 11.011h13.44v1.44H6.24v-1.44z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M5.872 10.43l8.347-6.176.86 1.163-8.347 6.176-.86-1.162zM5.9 13.087l8.346 6.177.864-1.168-8.347-6.176-.864 1.167zM18.72 8.613l5.28 3.12-5.28 3.12v-6.24z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M12.72 2.633L18.82 2 16.43 7.649 12.72 2.633zM12.72 21.307l6.1.633-2.389-5.649-3.711 5.016z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#F6ECFC",
        stroke: "#E0C1F4"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 8.759a2 2 0 00-2-2h-8c-1.105 0-2 .902-2 2.006v6.068a2 2 0 00.985 1.724l3.66-3.74 3.31 3.381 1.471-1.502 1.731 1.769c.51-.363.843-.958.843-1.632V8.76zM18.5 9c-.84 0-1.5.66-1.5 1.5s.66 1.5 1.5 1.5 1.5-.66 1.5-1.5S19.34 9 18.5 9z",
        fill: "#9736E8"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0h20a2 2 0 012 2v20a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm3.524 7.5a.624.624 0 01.203.527v7.126a.82.82 0 01-.218.707l-1.694 2.054v.271h4.803v-.27L6.924 15.86a.85.85 0 01-.233-.707V8.99l4.215 9.195h.49l3.62-9.195v7.33c0 .195 0 .232-.128.36l-1.302 1.265v.27h6.322v-.27l-1.257-1.235a.376.376 0 01-.143-.36V7.281a.376.376 0 01.143-.362l1.288-1.234v-.27h-4.457l-3.176 7.923-3.613-7.924H4.019v.271L5.524 7.5z",
        fill: "#12100E"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M8 8.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v.6a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-.6zM8 11.7a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v.6a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-.6zM8.5 14.401a.5.5 0 00-.5.5v.6a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-.6a.5.5 0 00-.5-.5h-7z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M6.455 19L2 22.5V4a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H6.455zM7 10v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 1a5 5 0 015 5v4a5 5 0 11-10 0V6a5 5 0 015-5zM3.055 11H5.07a7.002 7.002 0 0013.858 0h2.016A9.003 9.003 0 0113 18.945V23h-2v-4.055A9.004 9.004 0 013.055 11z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        y: 9.5,
        width: 24,
        height: 5,
        rx: .2,
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 11.5,
        stroke: "#C0C0CF"
      }), r.createElement("rect", {
        x: 7,
        y: 11,
        width: 10,
        height: 2,
        rx: 1,
        fill: "#4945FF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M13 18v2h4v2H7v-2h4v-2H2.992A1 1 0 012 16.993V4.007C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.986c0 .556-.455 1.007-.992 1.007H13z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M11.38 2.019a7.5 7.5 0 1010.6 10.6C21.662 17.854 17.316 22 12.001 22 6.477 22 2 17.523 2 12c0-5.315 4.146-9.661 9.38-9.981z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M7.3 13.8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12.3 13.8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17.3 13.8a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M11 11V5.828L9.172 7.657 7.757 6.243 12 2l4.243 4.243-1.415 1.414L13 5.828V11h5.172l-1.829-1.828 1.414-1.415L22 12l-4.243 4.243-1.414-1.415L18.172 13H13v5.172l1.828-1.829 1.415 1.414L12 22l-4.243-4.243 1.415-1.414L11 18.172V13H5.828l1.829 1.828-1.414 1.415L2 12l4.243-4.243 1.414 1.415L5.828 11H11z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M20 3v14a4 4 0 11-2-3.465V6H9v11a4 4 0 11-2-3.465V3h13z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#FCECEA",
        stroke: "#F5C0B8"
      }), r.createElement("path", {
        d: "M9.815 16h1.475V8.954H9.82L8 10.22v1.328l1.729-1.201h.087V16zm3.394 0h5.083v-1.187h-3.106v-.112l1.304-1.216c1.284-1.186 1.7-1.85 1.7-2.651v-.015c0-1.215-1.016-2.046-2.466-2.046-1.543 0-2.598.928-2.598 2.28l.005.02h1.362v-.024c0-.67.474-1.128 1.162-1.128.674 0 1.084.42 1.084 1.02v.015c0 .493-.268.85-1.26 1.812l-2.27 2.24V16zm9.067.156c1.646 0 2.744-.864 2.744-2.143v-.01c0-.957-.683-1.563-1.733-1.66v-.03c.825-.17 1.47-.742 1.47-1.62v-.01c0-1.123-.977-1.885-2.49-1.885-1.48 0-2.471.82-2.574 2.08l-.005.059h1.358l.005-.044c.058-.586.522-.962 1.216-.962.693 0 1.098.361 1.098.947v.01c0 .571-.478.962-1.22.962h-.787v1.05h.806c.855 0 1.357.37 1.357 1.044v.01c0 .596-.493 1.016-1.245 1.016-.761 0-1.264-.39-1.328-.938l-.005-.053h-1.41l.004.063c.098 1.26 1.148 2.114 2.74 2.114z",
        fill: "#D02B20"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.727 6v2.456h.666v.545H5.335v-.545h.666V6.701h-.666v-.493L6.727 6zm-.457 6.97l.006.023h1.116v.484H5.335v-.425l.965-1.003c.121-.139.221-.263.278-.371a.63.63 0 00.086-.284.41.41 0 00-.087-.274c-.058-.067-.144-.102-.26-.102a.277.277 0 00-.243.13.612.612 0 00-.09.332h-.672l-.004-.009a.92.92 0 01.27-.695c.185-.191.432-.286.74-.286.325 0 .58.08.763.24.182.161.274.381.274.66a.873.873 0 01-.146.499 6.246 6.246 0 01-.537.645l-.402.436zM7.308 16.7a.797.797 0 00-.373-.265.841.841 0 00.335-.266.614.614 0 00.126-.372c0-.27-.097-.48-.29-.627-.193-.148-.45-.221-.772-.221a1.14 1.14 0 00-.708.22.675.675 0 00-.279.585l.004.023h.669c0-.121.034-.159.102-.21a.385.385 0 01.236-.083c.114 0 .201.03.261.093a.33.33 0 01.09.235.389.389 0 01-.1.283.389.389 0 01-.285.106H6v.484h.323c.137 0 .243.04.319.106.075.066.113.175.113.319 0 .103-.036.19-.108.259a.405.405 0 01-.29.102.409.409 0 01-.27-.11.297.297 0 01-.111-.253h-.673l-.004.026c-.007.278.094.496.303.642.208.146.452.223.73.223.324 0 .59-.076.798-.232a.755.755 0 00.312-.64.688.688 0 00-.135-.427zm2.393-9.885h9v1.467h-9V6.816zm9 4.4h-9v1.467h9v-1.467zm-9 4.402h9v1.467h-9v-1.468z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M6.24 11.28H18v1.44H6.24v-1.44z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M5.871 10.699l8.347-6.176.86 1.162-8.347 6.177-.86-1.163zM5.899 13.354l8.346 6.176.864-1.167-8.347-6.176-.863 1.167z",
        fill: "#212134"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.6 14.399a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 14.399a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM16.8 22.8a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM16.8 6a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.6 14a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2zM20.4 14a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8zm0 1.2a3.6 3.6 0 100-7.2 3.6 3.6 0 000 7.2z",
        fill: "#212134"
      }), r.createElement("path", {
        d: "M6.24 10.881H18v1.44H6.24v-1.44z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.128 12.321a3.601 3.601 0 110-1.44H18.72v-2.4L24 11.6l-5.28 3.12v-2.4H7.128zM6 11.6a2.4 2.4 0 11-4.8 0 2.4 2.4 0 014.8 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 8.889a.86.86 0 01-.26.625l-6.125 6.222A.834.834 0 0112 16a.834.834 0 01-.615-.264L5.26 9.514A.861.861 0 015 8.889c0-.24.087-.45.26-.625A.834.834 0 015.875 8h12.25c.237 0 .442.088.615.264a.86.86 0 01.26.625z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 15.111c0-.24.087-.449.26-.625l6.125-6.222A.834.834 0 0112 8c.237 0 .442.088.615.264l6.125 6.222a.86.86 0 01.26.625.86.86 0 01-.26.625.834.834 0 01-.615.264H5.875a.835.835 0 01-.615-.264.86.86 0 01-.26-.625z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 01-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2zM7.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm9 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M4 3h16a1 1 0 011 1v5a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm2 9h6a1 1 0 011 1v3h1v6h-4v-6h1v-2H5a1 1 0 01-1-1v-2h2v1zm11.732 1.732l1.768-1.768 1.768 1.768a2.5 2.5 0 11-3.536 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.53-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M.5 3A2.5 2.5 0 013 .5h26A2.5 2.5 0 0131.5 3v18a2.5 2.5 0 01-2.5 2.5H3A2.5 2.5 0 01.5 21V3z",
        fill: "#FDF4DC",
        stroke: "#FAE7B9"
      }), r.createElement("path", {
        d: "M20.158 11.995c0-.591-.463-1.073-1.045-1.11H13.53V9.245a2.05 2.05 0 012.046-2.049c1.13 0 2.048.784 2.049 1.913 0 .24.194.433.433.433h.33a.433.433 0 00.433-.433C18.82 7.32 17.365 5.999 15.577 6a3.246 3.246 0 00-3.241 3.244v1.642h-.223c-.615 0-1.113.499-1.113 1.114v4.887c.001.615.5 1.113 1.115 1.113l6.93-.003c.616 0 1.114-.5 1.114-1.115l-.001-4.887z",
        fill: "#D9822F"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.604 3.514c.528.528.528 1.36 0 1.887l-2.622 2.607-4.99-4.99L18.6.396a1.322 1.322 0 011.887 0l3.118 3.118zM0 24v-4.99l14.2-14.2 4.99 4.99L4.99 24H0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M21 16.42v3.536a1 1 0 01-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 014.044 3H7.58a.5.5 0 01.498.45c.023.23.044.413.064.552A13.9 13.9 0 009.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 006.844 6.844l1.54-2.154a.462.462 0 01.573-.149 13.9 13.9 0 004 1.205c.139.02.322.042.55.064a.5.5 0 01.449.498H21z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.094 16.62V7.308h11.812v9.312H6.094zM5 6.42a.22.22 0 01.219-.22H18.78c.121 0 .219.098.219.22v11.087a.22.22 0 01-.219.222H5.22A.22.22 0 015 17.507V6.42zm9.426 5.105a1.22 1.22 0 100-2.442 1.22 1.22 0 000 2.442zm-6.599 3.789h8.135a.349.349 0 00.29-.554l-1.122-1.524a.348.348 0 00-.525-.045l-1.153 1.098-2.676-3.634a.349.349 0 00-.573.016l-2.676 4.106a.348.348 0 00.3.537z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M21.569 2.398H7.829v1.586h13.74c.47 0 .826.5.826 1.094v9.853l-2.791-3.17a2.13 2.13 0 00-.74-.55 2.214 2.214 0 00-.912-.196 2.215 2.215 0 00-.912.191 2.131 2.131 0 00-.74.546l-2.93 3.385-2.973-3.36a2.147 2.147 0 00-.741-.545 2.228 2.228 0 00-1.824.007c-.286.13-.538.319-.739.553l-2.931 3.432V7.653H2.51v9.894c.023.153.06.304.108.452v.127l.041.095c.057.142.126.28.207.412l.099.15c.074.107.157.207.247.302l.124.119c.13.118.275.222.43.309h.024c.36.214.775.327 1.198.325h16.515c.36-.004.716-.085 1.039-.24.323-.153.606-.375.827-.648a2.78 2.78 0 00.504-.888c.066-.217.108-.44.124-.666V5.078a2.497 2.497 0 00-.652-1.81 2.706 2.706 0 00-1.776-.87z",
        fill: "#32324D"
      }), r.createElement("path", {
        d: "M12.552 9.199c.912 0 1.651-.71 1.651-1.585 0-.876-.74-1.586-1.651-1.586-.912 0-1.652.71-1.652 1.586 0 .875.74 1.585 1.652 1.585zM3.303 6.408h.826V3.997h2.477v-.793-.793H4.129V0h-.826c-.219 0-.85.002-.826 0v2.411H0v1.586h2.477v2.41h.826z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M22.314 10.172l-1.415 1.414-.707-.707-4.242 4.242-.707 3.536-1.415 1.414-4.242-4.243-4.95 4.95-1.414-1.414 4.95-4.95-4.243-4.242 1.414-1.415L8.88 8.05l4.242-4.242-.707-.707 1.414-1.415 8.485 8.486z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1112.728 0zM12 13a2 2 0 100-4 2 2 0 000 4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M14 8.947L22 14v2l-8-2.526v5.36l3 1.666V22l-4.5-1L8 22v-1.5l3-1.667v-5.36L3 16v-2l8-5.053V3.5a1.5 1.5 0 113 0v5.447z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M4 20.252V3.748a1 1 0 011.507-.862l14.028 8.252a1 1 0 010 1.724L5.507 21.113A1 1 0 014 20.252z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M0 4a4 4 0 014-4h24a4 4 0 014 4v24a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
        fill: "#66B7F1"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 10.921a.5.5 0 01.773-.419l8.582 5.579a.5.5 0 010 .838l-8.582 5.579a.5.5 0 01-.773-.42V10.922z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M24 13.604a.3.3 0 01-.3.3h-9.795V23.7a.3.3 0 01-.3.3h-3.21a.3.3 0 01-.3-.3v-9.795H.3a.3.3 0 01-.3-.3v-3.21a.3.3 0 01.3-.3h9.795V.3a.3.3 0 01.3-.3h3.21a.3.3 0 01.3.3v9.795H23.7a.3.3 0 01.3.3v3.21z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "#212134"
      }), r.createElement("path", {
        d: "M17 12.569c0 .124-.1.224-.225.224h-3.981v3.982c0 .124-.101.225-.226.225h-1.136a.225.225 0 01-.226-.225v-3.981H7.226A.225.225 0 017 12.567v-1.136c0-.125.1-.226.225-.226h3.982V7.226c0-.124.1-.225.224-.225h1.138c.124 0 .224.1.224.225v3.982h3.982c.124 0 .225.1.225.224v1.138z",
        fill: "#F6F6F9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M10.9 2.1l9.9 1.415 1.413 9.9-9.192 9.192a1 1 0 01-1.414 0l-9.9-9.9a1 1 0 010-1.414L10.9 2.1zm2.828 8.486a2 2 0 102.828-2.83 2 2 0 00-2.828 2.83z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.58.448l3.177 3.176L18.66 1.72a3.267 3.267 0 114.62 4.62l-1.904 1.904 3.175 3.175a1.528 1.528 0 010 2.162l-3.175 3.175L20.2 15.58a3.267 3.267 0 10-4.62 4.62l1.177 1.177-3.176 3.176a1.528 1.528 0 01-2.162 0l-3.175-3.175-1.902 1.902a3.267 3.267 0 11-4.62-4.62l1.902-1.902-3.176-3.176a1.528 1.528 0 010-2.162l3.176-3.176L4.8 9.42a3.267 3.267 0 004.62-4.62L8.244 3.623 11.419.448a1.528 1.528 0 012.162 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M8.75 12.515l.017.104.103-.024a2.43 2.43 0 011.015.007c.368.08.719.251.954.547.319.405.477.905.477 1.492 0 .672-.213 1.199-.646 1.585-.437.39-.993.588-1.667.588-1.526 0-2.628-1.225-2.861-3.142h0c-.365-2.991 1.74-5.375 3.925-6.446l1.02 1.433a4.893 4.893 0 00-1.774 1.653c-.45.703-.688 1.495-.564 2.203zm6.583 0l.018.104.103-.024a2.415 2.415 0 011.012.007c.367.08.718.251.957.547.319.405.477.905.477 1.492 0 .672-.212 1.199-.645 1.585-.438.39-.993.588-1.668.588-1.525 0-2.62-1.225-2.853-3.142h0c-.365-2.991 1.733-5.375 3.917-6.446l1.02 1.433a4.894 4.894 0 00-1.773 1.653c-.45.703-.69 1.495-.565 2.203z",
        fill: "#32324D",
        stroke: "#fff",
        strokeWidth: .2
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M19.417 6.679C20.447 7.773 21 9 21 10.989c0 3.5-2.457 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.247-5.621-.537.278-1.24.375-1.93.311-1.803-.167-3.225-1.648-3.225-3.489a3.5 3.5 0 013.5-3.5c1.073 0 2.099.49 2.748 1.179zm-10 0C10.447 7.773 11 9 11 10.989c0 3.5-2.457 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.247-5.621-.537.278-1.24.375-1.93.311C4.592 12.322 3.17 10.841 3.17 9a3.5 3.5 0 013.5-3.5c1.073 0 2.099.49 2.748 1.179h-.001z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.634 12.018c0 6.583-5.263 11.92-11.754 11.92C5.388 23.938.125 18.6.125 12.018S5.388.098 11.88.098c6.491 0 11.754 5.337 11.754 11.92zM17.94 10.34a1.73 1.73 0 011.779 1.677c.012.67-.36 1.286-.95 1.585.012.175.012.35 0 .524 0 2.673-3.067 4.842-6.851 4.842s-6.852-2.172-6.852-4.842a3.925 3.925 0 010-.524 1.662 1.662 0 01-.461-.314 1.756 1.756 0 01-.076-2.46 1.697 1.697 0 012.425-.076 8.339 8.339 0 014.584-1.467l.868-4.136v-.006a.364.364 0 01.435-.282l2.881.584c.184-.326.517-.545.888-.584a1.18 1.18 0 011.295 1.058 1.188 1.188 0 01-1.044 1.313 1.18 1.18 0 01-1.294-1.058l-2.515-.536-.763 3.718a8.277 8.277 0 014.526 1.467 1.71 1.71 0 011.125-.483zm-8.798 1.677c-.648 0-1.177.536-1.177 1.194a1.19 1.19 0 001.177 1.194c.649 0 1.178-.536 1.178-1.194 0-.658-.53-1.194-1.178-1.194zm2.747 5.39a4.47 4.47 0 002.904-.919v.047a.339.339 0 00.006-.47.327.327 0 00-.465-.007 3.83 3.83 0 01-2.457.726 3.802 3.802 0 01-2.446-.75.314.314 0 00-.403 0 .327.327 0 00-.044.454 4.47 4.47 0 002.905.918zm1.516-4.155c0 .658.529 1.194 1.178 1.194l-.01.045h.06a1.186 1.186 0 001.127-1.239c0-.657-.529-1.194-1.178-1.194-.648 0-1.177.537-1.177 1.194z",
        fill: "#FF4500"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.681 2.804A9.64 9.64 0 0011.818 2C6.398 2 2 6.48 2 12c0 5.521 4.397 10 9.818 10 2.03 0 4.011-.641 5.67-1.835a9.987 9.987 0 003.589-4.831 1.117 1.117 0 00-.664-1.418 1.086 1.086 0 00-1.393.676 7.769 7.769 0 01-2.792 3.758 7.546 7.546 0 01-4.41 1.428V4.222h.002a7.492 7.492 0 013.003.625 7.61 7.61 0 012.5 1.762l.464.551-2.986 3.042a.186.186 0 00.129.316H22V3.317a.188.188 0 00-.112-.172.179.179 0 00-.199.04l-2.355 2.4-.394-.468-.02-.02a9.791 9.791 0 00-3.239-2.293zm-3.863 1.418V2v2.222zm0 0v15.556c-4.216 0-7.636-3.484-7.636-7.778s3.42-7.777 7.636-7.778z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M.5 3A2.5 2.5 0 013 .5h26A2.5 2.5 0 0131.5 3v18a2.5 2.5 0 01-2.5 2.5H3A2.5 2.5 0 01.5 21V3z",
        fill: "#F0F0FF",
        stroke: "#D9D8FF"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.375 16.316c.417-.407.625-.904.625-1.492 0-.589-.206-1.089-.618-1.5l-1.53-1.53a2.042 2.042 0 00-1.5-.617 2.06 2.06 0 00-1.529.646l-.646-.646c.43-.422.646-.934.646-1.537a2.03 2.03 0 00-.61-1.493l-1.515-1.522a2.014 2.014 0 00-1.5-.625 2.03 2.03 0 00-1.492.61l-1.081 1.074A2.006 2.006 0 0010 9.176c0 .589.206 1.089.618 1.5l1.53 1.53c.41.412.91.617 1.5.617a2.06 2.06 0 001.529-.646l.646.646a2.069 2.069 0 00-.646 1.537c0 .588.203 1.086.61 1.493l1.514 1.522c.407.417.907.625 1.5.625a2.03 2.03 0 001.493-.61l1.081-1.074zm-5.956-6.678a.68.68 0 00-.205-.5l-1.515-1.522a.68.68 0 00-.5-.206.71.71 0 00-.5.199l-1.081 1.073a.672.672 0 00-.206.493.68.68 0 00.206.5l1.53 1.53a.678.678 0 00.5.198.71.71 0 00.529-.228l-.14-.136a4.46 4.46 0 01-.158-.158 1.756 1.756 0 01-.11-.14.593.593 0 01-.122-.39.68.68 0 01.206-.5.68.68 0 01.5-.206.59.59 0 01.39.121c.064.047.11.084.14.111.03.027.082.08.158.158l.136.14a.713.713 0 00.242-.537zm5.168 5.187a.68.68 0 00-.206-.5l-1.529-1.53a.68.68 0 00-.5-.205.7.7 0 00-.53.235l.14.136c.079.076.132.129.159.158.027.03.063.076.11.14a.591.591 0 01.121.39.681.681 0 01-.206.5.681.681 0 01-.5.206.591.591 0 01-.39-.121 1.746 1.746 0 01-.14-.111 4.395 4.395 0 01-.157-.158 20.642 20.642 0 00-.136-.14.714.714 0 00-.037 1.037l1.515 1.522a.678.678 0 00.5.198.708.708 0 00.5-.19l1.08-1.074a.672.672 0 00.206-.493z",
        fill: "#4945FF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M6 4h15a1 1 0 011 1v7h-2V6H6v3L1 5l5-4v3zm12 16H3a1 1 0 01-1-1v-7h2v6h14v-3l5 4-5 4v-3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M21 2v20h-2v-8h-3V7a5 5 0 015-5zM9 13.9V22H7v-8.1A5.002 5.002 0 013 9V3h2v7h2V3h2v7h2V3h2v6a5.002 5.002 0 01-4 4.9z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#EAF5FF",
        stroke: "#B8E1FF"
      }), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.286 9.286v-.857a.397.397 0 00-.138-.302A.465.465 0 0018.82 8h-8.357a.465.465 0 00-.326.127.397.397 0 00-.138.302v.857c0 .116.046.216.138.301.092.085.2.127.326.127h8.357a.465.465 0 00.327-.127.397.397 0 00.138-.301zm2.785 2.713v.857a.397.397 0 01-.137.301.465.465 0 01-.327.128H10.464a.465.465 0 01-.326-.128.397.397 0 01-.138-.301v-.857c0-.116.046-.217.138-.302a.465.465 0 01.326-.127h11.143c.126 0 .235.043.327.127a.397.397 0 01.137.302zm-1.857 3.574v.857a.397.397 0 01-.137.302.465.465 0 01-.327.127h-9.286a.465.465 0 01-.326-.127.397.397 0 01-.138-.302v-.857c0-.116.046-.216.138-.301a.465.465 0 01.326-.127h9.286c.126 0 .235.042.326.127a.397.397 0 01.138.301z",
        fill: "#0C75AF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M8.498 20h7.004A6.523 6.523 0 0112 23.502 6.523 6.523 0 018.498 20zM18 14.805l2 2.268V19H4v-1.927l2-2.268V9c0-3.483 2.504-6.447 6-7.545C15.496 2.553 18 5.517 18 9v5.805zM12 11a2 2 0 100-4 2 2 0 000 4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 14.121l-2.317 2.317a4 4 0 11-2.12-2.121L9.88 12 4.21 6.333a2 2 0 010-2.829l.708-.707L12 9.88l7.081-7.082.708.707a1.999 1.999 0 010 2.829L14.12 12l2.317 2.317a4 4 0 11-2.12 2.121L12 14.12v.001zM6 20a2 2 0 100-4 2 2 0 000 4zm12 0a2 2 0 100-4 2 2 0 000 4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.813 20.163l-5.3-5.367a9.792 9.792 0 001.312-4.867C19.825 4.455 15.375 0 9.913 0 4.45 0 0 4.455 0 9.929c0 5.473 4.45 9.928 9.912 9.928a9.757 9.757 0 005.007-1.4l5.275 5.35a.634.634 0 00.913 0l2.706-2.737a.641.641 0 000-.907zM9.91 3.867c3.338 0 6.05 2.718 6.05 6.061s-2.712 6.061-6.05 6.061c-3.337 0-6.05-2.718-6.05-6.06 0-3.344 2.713-6.062 6.05-6.062z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.813 20.163l-5.3-5.367a9.792 9.792 0 001.312-4.867C19.825 4.455 15.375 0 9.913 0 4.45 0 0 4.455 0 9.929c0 5.473 4.45 9.928 9.912 9.928a9.757 9.757 0 005.007-1.4l5.275 5.35a.634.634 0 00.913 0l2.706-2.737a.641.641 0 000-.907zM9.91 3.867c3.338 0 6.05 2.718 6.05 6.061s-2.712 6.061-6.05 6.061c-3.337 0-6.05-2.718-6.05-6.06 0-3.344 2.713-6.062 6.05-6.062z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M22 7v2.5a6.499 6.499 0 01-6.5 6.5H13v5h-2v-7l.019-1A6.5 6.5 0 0117.5 7H22zM6 3a7.004 7.004 0 016.643 4.786A7.477 7.477 0 0010.016 13H9a7 7 0 01-7-7V3h4z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M4 3h16a1 1 0 011 1v7H3V4a1 1 0 011-1zM3 13h18v7a1 1 0 01-1 1H4a1 1 0 01-1-1v-7zm4 3v2h3v-2H7zM7 6v2h3V6H7z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.738 23.966C4.905 21.624 0 18.49 0 11.043V3.772c0-.331.275-.6.615-.6C4.971 3.17 9.159 1.792 11.647.074A.516.516 0 0111.942 0h.115c.103 0 .21.016.295.074 2.535 1.72 6.676 3.096 11.033 3.098.34 0 .615.269.615.6v7.271c0 7.447-4.906 10.582-11.739 12.923a.63.63 0 01-.204.034h-.115a.631.631 0 01-.204-.034zm.16-11.175c-2.944 0-5.334 1.153-5.334 4.003H17.23c0-2.85-2.39-4.003-5.333-4.003zM12 6.188a2.501 2.501 0 010 5 2.501 2.501 0 010-5z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M14.515 5l2.606-2.607a1 1 0 011.415 0l4.242 4.243a1 1 0 010 1.414L19 11.828V21a1 1 0 01-1 1H6a1 1 0 01-1-1v-9.172L1.222 8.05a1 1 0 010-1.414l4.242-4.243a1 1 0 011.415 0L9.485 5h5.03z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.12 3.907c-.025 0-.055-.005-.087-.011a.72.72 0 00-.13-.016H5.929l-.27-1.805A2.413 2.413 0 003.26 0H1.078C.485 0 0 .485 0 1.078c0 .593.485 1.078 1.078 1.078H3.26c.135 0 .243.107.27.242L5.2 13.77a2.954 2.954 0 002.91 2.506h11.21c1.401 0 2.614-.997 2.91-2.371l1.752-8.757a1.065 1.065 0 00-.863-1.24zm-4.932 13.927a2.8 2.8 0 00-2.802 2.802 2.8 2.8 0 002.802 2.802 2.8 2.8 0 002.803-2.802c-.027-1.536-1.267-2.802-2.803-2.802zm-9.646 0a2.786 2.786 0 012.775 2.667c.081 1.536-1.132 2.83-2.667 2.91h-.054a2.762 2.762 0 01-2.749-2.667 2.819 2.819 0 012.695-2.91z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#0C75AF",
        stroke: "#0C75AF"
      }), r.createElement("path", {
        d: "M8.523 13.586c.106 1.64 1.418 2.63 3.34 2.63 2.098 0 3.516-1.113 3.516-2.788 0-1.143-.65-1.846-2.086-2.297l-.867-.27c-.797-.252-1.137-.597-1.137-1.066 0-.598.633-1.031 1.459-1.031.873 0 1.512.474 1.617 1.183h1.67c-.053-1.54-1.36-2.619-3.217-2.619-1.91 0-3.328 1.131-3.328 2.678 0 1.09.715 1.922 1.963 2.309l.879.275c.914.287 1.266.592 1.266 1.084 0 .662-.657 1.107-1.606 1.107-.914 0-1.635-.469-1.758-1.195h-1.71zM20.107 16l1.489-6.943h2.531l.31-1.512h-6.843l-.31 1.512h2.53L18.326 16h1.781z",
        fill: "#fff"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M13 17v3h5v2H6v-2h5v-3H4a1 1 0 01-1-1V4H2V2h20v2h-1v12a1 1 0 01-1 1h-7zM10 6v7l5-3.5L10 6z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M30.113 7.768a16.772 16.772 0 00-6.635-3.317c-2.505-.634-5.23-.598-7.854.096-.313.065-.6.166-.879.265l-.123.042c-.102.035-.203.07-.308.108a7.57 7.57 0 00-.655.247c-.164.078-.325.148-.488.221-.44.198-.893.403-1.29.657-1.314.71-2.42 1.674-3.247 2.448-1.922 1.931-3.355 4.359-4.035 6.832l-.093.37c-.131.516-.27 1.049-.322 1.572-.012.107-.033.214-.047.318-.032.218-.065.431-.078.664l-.051 1.097c-.005.11-.011.225-.006.358l.073 1.44.148.993c.041.283.085.581.164.85.553 2.391 1.627 4.609 3.103 6.41a15.664 15.664 0 004.951 3.997l.969.468c.092.04.168.07.242.096l.116.04c.152.053.295.106.444.16.276.106.546.206.843.295l1.26.32c.265.052.531.091.79.128.135.021.27.038.429.065 1.532.166 2.95.147 4.087-.058.092-.016.182-.026.272-.04.183-.025.368-.048.531-.092l1.284-.319 1.307-.456a.502.502 0 00-.318-.951l-1.277.396-1.246.257c-.135.026-.277.04-.422.056-.1.004-.196.02-.305.03-1.048.148-2.342.115-3.728-.089-.137-.024-.272-.05-.405-.074-.24-.046-.477-.09-.695-.142l-1.16-.338c-.248-.087-.497-.19-.75-.292a8.766 8.766 0 00-.433-.177l-.116-.05c-.055-.022-.117-.045-.145-.06l-.895-.474a14.106 14.106 0 01-4.296-3.739c-1.24-1.637-2.115-3.632-2.527-5.76-.42-2.045-.27-4.382.422-6.577.633-2.004 1.756-3.82 3.34-5.404.103-.104.207-.208.295-.29.778-.67 1.714-1.42 2.822-1.962.312-.184.66-.327 1.027-.475.175-.071.346-.142.488-.203.158-.058.327-.112.49-.162.107-.03.213-.065.306-.091l.123-.042c.227-.07.436-.137.668-.174l.836-.17c.163-.03.332-.046.498-.065.111-.011.215-.016.336-.032.384-.06.77-.062 1.185-.063.147 0 .3.001.465-.008.14-.006.292.013.455.03.11.01.216.022.297.027.109.01.21.022.322.03.166.01.318.025.458.051.187.041.377.075.57.106.346.063.673.126.989.238a13.246 13.246 0 015.263 2.872 12.87 12.87 0 013.122 4.294c.628 1.403 1.014 2.895 1.104 4.328.017.201.02.398.021.592-.002.126.003.25.006.356a1.64 1.64 0 00.003.187c.005.086.005.171 0 .242l-.038.448c-.014.119-.02.23-.03.34a4.2 4.2 0 01-.043.466l-.145.787c-.042.298-.121.554-.194.793-.035.13-.078.254-.096.348-.026.074-.042.143-.061.209-.021.078-.037.151-.078.244l-.545 1.354a2.02 2.02 0 001.212 2.57 2.002 2.002 0 002.1-.459c.208-.208.366-.456.464-.735l.465-1.298c.045-.121.092-.287.134-.457l.059-.235c.028-.118.06-.242.096-.377.103-.388.22-.833.268-1.281l.132-.955c.028-.233.036-.47.045-.711.005-.114.009-.233.018-.36l.029-.567c0-.128-.01-.27-.018-.406l-.008-.21a18.315 18.315 0 01-.017-.387 7.82 7.82 0 00-.067-.832c-.194-1.838-.752-3.734-1.623-5.499a16.385 16.385 0 00-4.154-5.293z",
        fill: "#4945FF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M20.083 10.5l1.202.721a.501.501 0 010 .858L12 17.65l-9.285-5.571a.5.5 0 010-.858l1.202-.721L12 15.35l8.083-4.85zm0 4.7l1.202.721a.501.501 0 010 .858l-8.77 5.262a1 1 0 01-1.03 0l-8.77-5.262a.5.5 0 010-.858l1.202-.721L12 20.05l8.083-4.85zM12.514 1.309l8.771 5.262a.5.5 0 010 .858L12 13 2.715 7.429a.5.5 0 010-.858l8.77-5.262a1 1 0 011.03 0z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 18.26l-7.053 3.948 1.575-7.928L.587 8.792l8.027-.952L12 .5l3.386 7.34 8.027.952-5.935 5.488 1.575 7.928L12 18.26z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M22 20v2H2v-2h1v-6.758A4.496 4.496 0 011 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 01.866-.5H18.79a1 1 0 01.866.5l2.702 4.682A4.496 4.496 0 0121 13.242V20h1zM5.789 4L3.356 8.213a2.5 2.5 0 004.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 004.644 0c.335-.837 1.52-.837 1.856 0a2.501 2.501 0 104.457-2.232L18.21 4H5.789z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.498 0H7.68v8.035h7.783c.278 0 .503.224.503.502v7.783H24V.502A.502.502 0 0023.498 0z",
        fill: "#8E75FF"
      }), r.createElement("path", {
        opacity: .405,
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.68 0v8.035H.252a.25.25 0 01-.178-.429L7.68 0zm8.715 23.926a.251.251 0 01-.43-.177V16.32H24l-7.605 7.606zm-.68-15.891H7.68v7.783c0 .278.225.502.503.502h7.783V8.286a.251.251 0 00-.252-.251z",
        fill: "#8E75FF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.41 6.655c.38.054.654.109.817.218.218.109.328.218.437.327.109.164.163.436.218.655l.436 1.963h1.091V6H6.827L6.5 9.818h.982l.545-2.182c.055-.218.164-.436.218-.545.11-.11.273-.218.491-.327.219-.055.491-.164.873-.164.327 0 .764-.055 1.31-.055v4.91H6.554v1.09h4.363v4.146c0 .109.055.164-.054.218-.11.055-.219.11-.491.11l-1.146.217-.054.764h5.563l-.054-.764-1.146-.163c-.272 0-.381-.055-.436-.11-.11-.054-.054-.108-.054-.218v-4.2h4.363v-1.09h-4.363v-4.91c.545 0 1.036.055 1.363.11z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 18a6 6 0 110-12 6 6 0 010 12zM11 1h2v3h-2V1zm0 19h2v3h-2v-3zM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93v-.001zM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121zm2.121-14.85l1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121v-.001zM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121zM23 11v2h-3v-2h3zM4 11v2H1v-2h3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M15.414 5h5.594c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.996.996 0 012 20V6c0-.552.455-1 .992-1h5.594L6.05 2.464 7.464 1.05 11.414 5h1.172l3.95-3.95 1.414 1.414L15.414 5z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("rect", {
        x: .5,
        y: .5,
        width: 31,
        height: 23,
        rx: 2.5,
        fill: "#EAFBE7",
        stroke: "#C6F0C2"
      }), r.createElement("path", {
        d: "M8.62 16h1.857l.627-2.05h2.982l.627 2.05h1.863l-2.941-8.455h-2.08L8.619 16zm3.925-6.768h.105l1.032 3.393h-2.174l1.037-3.393zM21.65 16.1c1.612 0 2.62-1.26 2.62-3.323v-.011c0-2.075-.985-3.323-2.62-3.323-.884 0-1.605.434-1.933 1.137h-.106V7.082h-1.71V16h1.71v-1.002h.106c.334.697 1.02 1.102 1.933 1.102zm-.585-1.418c-.903 0-1.471-.715-1.471-1.899v-.011c0-1.184.574-1.91 1.47-1.91.903 0 1.465.726 1.465 1.904v.011c0 1.19-.556 1.905-1.465 1.905z",
        fill: "#328048"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M22 15h-3V3h3a1 1 0 011 1v10a1 1 0 01-1 1zm-5.293 1.293l-6.4 6.4a.5.5 0 01-.654.047L8.8 22.1a1.5 1.5 0 01-.553-1.57L9.4 16H3a2 2 0 01-2-2v-2.104a2 2 0 01.15-.762L4.246 3.62A1 1 0 015.17 3H16a1 1 0 011 1v11.586a1 1 0 01-.293.707z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M2 9h3v12H2a1 1 0 01-1-1V10a1 1 0 011-1zm5.293-1.293l6.4-6.4a.5.5 0 01.654-.047l.853.64a1.5 1.5 0 01.553 1.57L14.6 8H21a2 2 0 012 2v2.104a2 2 0 01-.15.762l-3.095 7.515a1 1 0 01-.925.619H8a1 1 0 01-1-1V8.414a1 1 0 01.293-.707z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M17.2 20l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 01-2-2V7a4 4 0 014-4h10a4 4 0 014 4v11a2 2 0 01-2 2h-1.8zM11 12V5H7a2 2 0 00-2 2v5h6zm2 0h6V7a2 2 0 00-2-2h-4v7zm-5.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm9 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M3.236 6.149a.2.2 0 00-.197.233L6 24h12l2.96-17.618a.2.2 0 00-.196-.233H3.236zM21.8 1.983c.11 0 .2.09.2.2v1.584a.2.2 0 01-.2.2H2.2a.2.2 0 01-.2-.2V2.183c0-.11.09-.2.2-.2h5.511c.9 0 1.631-1.09 1.631-1.983h5.316c0 .894.73 1.983 1.631 1.983H21.8z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M24 4.557a9.83 9.83 0 01-2.828.775 4.932 4.932 0 002.165-2.724 9.864 9.864 0 01-3.127 1.195 4.916 4.916 0 00-3.594-1.555c-3.179 0-5.515 2.966-4.797 6.045A13.978 13.978 0 011.671 3.149a4.93 4.93 0 001.523 6.574 4.903 4.903 0 01-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.935 4.935 0 01-2.224.084 4.928 4.928 0 004.6 3.419A9.9 9.9 0 010 19.54a13.94 13.94 0 007.548 2.212c9.142 0 14.307-7.721 13.995-14.646A10.025 10.025 0 0024 4.557z",
        fill: "#1DA1F2"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M17.654 1.7l-2.782 2.533a9.138 9.138 0 013.49 1.973c3.512 3.2 3.512 8.388 0 11.588-2.592 2.36-6.598 3.862-12.016 4.506l2.782-2.533a9.138 9.138 0 01-3.49-1.973c-3.512-3.2-3.533-8.369 0-11.588C8.23 3.846 12.237 2.344 17.655 1.7h-.001zM12 8c-2.485 0-4.5 1.79-4.5 4s2.015 4 4.5 4 4.5-1.79 4.5-4-2.015-4-4.5-4z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 32 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M.5 3A2.5 2.5 0 013 .5h26A2.5 2.5 0 0131.5 3v18a2.5 2.5 0 01-2.5 2.5H3A2.5 2.5 0 01.5 21V3z",
        fill: "#F0F0FF",
        stroke: "#D9D8FF"
      }), r.createElement("path", {
        d: "M14.907 9.438c0 .375 0 .738.118 1.078-1.243 1.46-4.526 5.317-4.832 5.611a.582.582 0 00-.193.433c0 .245.15.481.277.614.19.2 1.004.952 1.154.808.444-.433.533-.548.715-.727.274-.268-.029-.816.066-1.039.096-.222.197-.265.361-.3.165-.034.456.084.684.087.24.003.369-.098.548-.265.144-.133.248-.257.25-.45.007-.26-.368-.603-.089-.877.28-.274.684.178.981.144.297-.035.658-.447.695-.623.038-.176-.337-.629-.28-.886.02-.086.197-.288.33-.317.132-.029.72.199.853.17.162-.034.35-.205.502-.3.447.193.854.271 1.376.271C20.4 12.87 22 11.33 22 9.432 22 7.534 20.399 6 18.423 6s-3.516 1.54-3.516 3.438zm5.247-.669a.923.923 0 11-1.847 0 .923.923 0 011.847 0z",
        fill: "#4945FF"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M12 15.2a4.358 4.358 0 002.992-1.172A3.892 3.892 0 0016.23 11.2V6h-1.693v5.2c0 .636-.267 1.247-.743 1.697A2.615 2.615 0 0112 13.6a2.615 2.615 0 01-1.795-.703 2.336 2.336 0 01-.743-1.697V6H7.769v5.2c0 1.06.446 2.078 1.24 2.828A4.358 4.358 0 0012 15.2zM17.5 16.4h-11V18h11v-1.6z",
        fill: "#32324D"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.571 18.272H10.43v-8.47H2.487a.2.2 0 01-.14-.343L11.858.058a.2.2 0 01.282 0l9.513 9.4a.2.2 0 01-.14.343H13.57v8.47zM2.2 21.095a.2.2 0 00-.2.2v2.424c0 .11.09.2.2.2h19.6a.2.2 0 00.2-.2v-2.424a.2.2 0 00-.2-.2H2.2z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M20 22H4v-2a5 5 0 015-5h6a5 5 0 015 5v2zm-8-9A6 6 0 1112 .998 6 6 0 0112 13z",
        fill: "#8E8EA9"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M5.889 16H2a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L5.89 16h-.001zm14.525-4l3.536 3.536-1.414 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.464l1.414-1.414L19 10.586l3.536-3.536 1.414 1.414L20.414 12z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M5.889 16H2a1 1 0 01-1-1V9a1 1 0 011-1h3.889l5.294-4.332a.5.5 0 01.817.387v15.89a.5.5 0 01-.817.387L5.89 16h-.001zm13.517 4.134l-1.416-1.416A8.977 8.977 0 0021 12a8.983 8.983 0 00-3.304-6.968l1.42-1.42A10.977 10.977 0 0123 12c0 3.223-1.386 6.122-3.594 8.134zm-3.543-3.543l-1.422-1.422A3.992 3.992 0 0016 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.99 5.99 0 0118 12c0 1.842-.83 3.49-2.137 4.591z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        d: "M7.617 8.712l3.205-2.328c.36-.263.797-.398 1.243-.384a2.616 2.616 0 012.427 1.82c.186.583.356.977.51 1.182A4.992 4.992 0 0019 11v2a6.987 6.987 0 01-5.402-2.547l-.697 3.955 2.061 1.73 2.223 6.108-1.88.684-2.04-5.604-3.39-2.845a2 2 0 01-.713-1.904l.509-2.885-.677.492-2.127 2.928-1.618-1.176L7.6 8.7l.017.012zM13.5 5.5a2 2 0 110-4 2 2 0 010 4zm-2.972 13.181l-3.214 3.83-1.532-1.285 2.976-3.546.746-2.18 1.791 1.5-.767 1.681z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.557 6.762a2.381 2.381 0 100-4.762 2.381 2.381 0 000 4.762zm-2.655-.5a.962.962 0 01.12.066l2.397 1.556a.952.952 0 01.28 1.318l-2.536 3.905c.07.104.138.212.201.322h4.67c.056 0 .112.005.165.016a1.258 1.258 0 011.044 1.807l-2.492 5.103a1.258 1.258 0 01-2.26-1.104L17.077 16h-1.957a5.714 5.714 0 11-5.017-5.387l1.818-2.798-1.642-1.067-1.173 1.463a.96.96 0 01-1.525-1.165L8.94 5.182a1.905 1.905 0 012.593-.465l.246.163-.002.002 2.125 1.38zM9.414 20.095a3.81 3.81 0 100-7.619 3.81 3.81 0 000 7.62z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(0);
    function a() {
      return (a = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
        return t;
      }).apply(this, arguments);
    }
    e.default = function (t) {
      return r.createElement("svg", a({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, t), r.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.707.297A1 1 0 0023 .004h-2a13.907 13.907 0 00-5.38 1.077 1 1 0 00-.615.923V4.92a.035.035 0 01-.022.038l-2-1.47a1 1 0 00-1.265.052A14 14 0 007 14.004v1.585l-2.707 2.707a1 1 0 101.415 1.415l2.707-2.708H10a14.014 14.014 0 0014-14v-2a1 1 0 00-.293-.706zM18 23.999H3a3 3 0 01-3-3V6A3 3 0 013 3h3a1 1 0 110 2H3a1 1 0 00-1 1v15a1 1 0 001 1h15a1 1 0 001-1v-3a1 1 0 112 0v3a3 3 0 01-3 3z",
        fill: "#212134"
      }));
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(1);
    n.d(e, "Alien", function () {
      return r.default;
    });
    var a = n(2);
    n.d(e, "Apps", function () {
      return a.default;
    });
    var l = n(3);
    n.d(e, "Archive", function () {
      return l.default;
    });
    var i = n(4);
    n.d(e, "ArrowDown", function () {
      return i.default;
    });
    var c = n(5);
    n.d(e, "ArrowLeft", function () {
      return c.default;
    });
    var o = n(6);
    n.d(e, "ArrowRight", function () {
      return o.default;
    });
    var u = n(7);
    n.d(e, "ArrowUp", function () {
      return u.default;
    });
    var f = n(8);
    n.d(e, "Attachment", function () {
      return f.default;
    });
    var h = n(9);
    n.d(e, "Bell", function () {
      return h.default;
    });
    var v = n(10);
    n.d(e, "Bold", function () {
      return v.default;
    });
    var s = n(11);
    n.d(e, "Book", function () {
      return s.default;
    });
    var p = n(12);
    n.d(e, "Boolean", function () {
      return p.default;
    });
    var d = n(13);
    n.d(e, "Briefcase", function () {
      return d.default;
    });
    var w = n(14);
    n.d(e, "Brush", function () {
      return w.default;
    });
    var m = n(15);
    n.d(e, "BulletList", function () {
      return m.default;
    });
    var g = n(16);
    n.d(e, "Calendar", function () {
      return g.default;
    });
    var y = n(17);
    n.d(e, "Car", function () {
      return y.default;
    });
    var z = n(18);
    n.d(e, "CarretDown", function () {
      return z.default;
    });
    var O = n(19);
    n.d(e, "CarretUp", function () {
      return O.default;
    });
    var E = n(20);
    n.d(e, "Cast", function () {
      return E.default;
    });
    var x = n(21);
    n.d(e, "ChartBubble", function () {
      return x.default;
    });
    var M = n(22);
    n.d(e, "ChartCircle", function () {
      return M.default;
    });
    var b = n(23);
    n.d(e, "ChartPie", function () {
      return b.default;
    });
    var j = n(24);
    n.d(e, "Check", function () {
      return j.default;
    });
    var H = n(25);
    n.d(e, "CheckCircle", function () {
      return H.default;
    });
    var B = n(26);
    n.d(e, "ChevronDown", function () {
      return B.default;
    });
    var V = n(27);
    n.d(e, "ChevronLeft", function () {
      return V.default;
    });
    var P = n(28);
    n.d(e, "ChevronRight", function () {
      return P.default;
    });
    var L = n(29);
    n.d(e, "ChevronUp", function () {
      return L.default;
    });
    var A = n(30);
    n.d(e, "Clock", function () {
      return A.default;
    });
    var F = n(31);
    n.d(e, "Cloud", function () {
      return F.default;
    });
    var R = n(32);
    n.d(e, "CloudUpload", function () {
      return R.default;
    });
    var C = n(33);
    n.d(e, "Code", function () {
      return C.default;
    });
    var D = n(34);
    n.d(e, "CodeSquare", function () {
      return D.default;
    });
    var k = n(35);
    n.d(e, "Cog", function () {
      return k.default;
    });
    var S = n(36);
    n.d(e, "Collapse", function () {
      return S.default;
    });
    var T = n(37);
    n.d(e, "CollectionType", function () {
      return T.default;
    });
    var W = n(38);
    n.d(e, "Command", function () {
      return W.default;
    });
    var _ = n(39);
    n.d(e, "Component", function () {
      return _.default;
    });
    var U = n(40);
    n.d(e, "Connector", function () {
      return U.default;
    });
    var I = n(41);
    n.d(e, "Crop", function () {
      return I.default;
    });
    var q = n(42);
    n.d(e, "Cross", function () {
      return q.default;
    });
    var G = n(43);
    n.d(e, "CrossCircle", function () {
      return G.default;
    });
    var Q = n(44);
    n.d(e, "Crown", function () {
      return Q.default;
    });
    var N = n(45);
    n.d(e, "Cup", function () {
      return N.default;
    });
    var J = n(46);
    n.d(e, "Cursor", function () {
      return J.default;
    });
    var K = n(47);
    n.d(e, "Dashboard", function () {
      return K.default;
    });
    var Z = n(48);
    n.d(e, "Database", function () {
      return Z.default;
    });
    var X = n(49);
    n.d(e, "Date", function () {
      return X.default;
    });
    var Y = n(50);
    n.d(e, "Discord", function () {
      return Y.default;
    });
    var $ = n(51);
    n.d(e, "Discourse", function () {
      return $.default;
    });
    var tt = n(52);
    n.d(e, "Discuss", function () {
      return tt.default;
    });
    var et = n(53);
    n.d(e, "Doctor", function () {
      return et.default;
    });
    var nt = n(54);
    n.d(e, "Dot", function () {
      return nt.default;
    });
    var rt = n(55);
    n.d(e, "Download", function () {
      return rt.default;
    });
    var at = n(56);
    n.d(e, "Drag", function () {
      return at.default;
    });
    var lt = n(57);
    n.d(e, "Duplicate", function () {
      return lt.default;
    });
    var it = n(58);
    n.d(e, "DynamicZone", function () {
      return it.default;
    });
    var ct = n(59);
    n.d(e, "Earth", function () {
      return ct.default;
    });
    var ot = n(60);
    n.d(e, "EarthStriked", function () {
      return ot.default;
    });
    var ut = n(61);
    n.d(e, "Email", function () {
      return ut.default;
    });
    var ft = n(62);
    n.d(e, "EmotionHappy", function () {
      return ft.default;
    });
    var ht = n(63);
    n.d(e, "EmotionUnhappy", function () {
      return ht.default;
    });
    var vt = n(64);
    n.d(e, "EmptyDocuments", function () {
      return vt.default;
    });
    var st = n(65);
    n.d(e, "EmptyPermissions", function () {
      return st.default;
    });
    var pt = n(66);
    n.d(e, "EmptyPictures", function () {
      return pt.default;
    });
    var dt = n(67);
    n.d(e, "Enumeration", function () {
      return dt.default;
    });
    var wt = n(68);
    n.d(e, "Envelop", function () {
      return wt.default;
    });
    var mt = n(69);
    n.d(e, "Equalizer", function () {
      return mt.default;
    });
    var gt = n(70);
    n.d(e, "ExclamationMarkCircle", function () {
      return gt.default;
    });
    var yt = n(71);
    n.d(e, "Exit", function () {
      return yt.default;
    });
    var zt = n(72);
    n.d(e, "Expand", function () {
      return zt.default;
    });
    var Ot = n(73);
    n.d(e, "ExternalLink", function () {
      return Ot.default;
    });
    var Et = n(74);
    n.d(e, "Eye", function () {
      return Et.default;
    });
    var xt = n(75);
    n.d(e, "EyeStriked", function () {
      return xt.default;
    });
    var Mt = n(76);
    n.d(e, "Facebook", function () {
      return Mt.default;
    });
    var bt = n(77);
    n.d(e, "Feather", function () {
      return bt.default;
    });
    var jt = n(78);
    n.d(e, "FeatherSquare", function () {
      return jt.default;
    });
    var Ht = n(79);
    n.d(e, "File", function () {
      return Ht.default;
    });
    var Bt = n(80);
    n.d(e, "FileError", function () {
      return Bt.default;
    });
    var Vt = n(81);
    n.d(e, "FilePdf", function () {
      return Vt.default;
    });
    var Pt = n(82);
    n.d(e, "Filter", function () {
      return Pt.default;
    });
    var Lt = n(83);
    n.d(e, "Folder", function () {
      return Lt.default;
    });
    var At = n(84);
    n.d(e, "Gate", function () {
      return At.default;
    });
    var Ft = n(85);
    n.d(e, "Gift", function () {
      return Ft.default;
    });
    var Rt = n(86);
    n.d(e, "Github", function () {
      return Rt.default;
    });
    var Ct = n(87);
    n.d(e, "GlassesSquare", function () {
      return Ct.default;
    });
    var Dt = n(88);
    n.d(e, "Globe", function () {
      return Dt.default;
    });
    var kt = n(89);
    n.d(e, "GraphQl", function () {
      return kt.default;
    });
    var St = n(90);
    n.d(e, "HandHeart", function () {
      return St.default;
    });
    var Tt = n(91);
    n.d(e, "Hashtag", function () {
      return Tt.default;
    });
    var Wt = n(92);
    n.d(e, "Headphone", function () {
      return Wt.default;
    });
    var _t = n(93);
    n.d(e, "Heart", function () {
      return _t.default;
    });
    var Ut = n(94);
    n.d(e, "House", function () {
      return Ut.default;
    });
    var It = n(95);
    n.d(e, "IndentDecrease", function () {
      return It.default;
    });
    var qt = n(96);
    n.d(e, "IndentIncrease", function () {
      return qt.default;
    });
    var Gt = n(97);
    n.d(e, "Information", function () {
      return Gt.default;
    });
    var Qt = n(98);
    n.d(e, "InformationSquare", function () {
      return Qt.default;
    });
    var Nt = n(99);
    n.d(e, "Italic", function () {
      return Nt.default;
    });
    var Jt = n(100);
    n.d(e, "Json", function () {
      return Jt.default;
    });
    var Kt = n(101);
    n.d(e, "Key", function () {
      return Kt.default;
    });
    var Zt = n(102);
    n.d(e, "Landscape", function () {
      return Zt.default;
    });
    var Xt = n(103);
    n.d(e, "LandscapeSmall", function () {
      return Xt.default;
    });
    var Yt = n(104);
    n.d(e, "Layer", function () {
      return Yt.default;
    });
    var $t = n(105);
    n.d(e, "Layout", function () {
      return $t.default;
    });
    var te = n(106);
    n.d(e, "Lightbulb", function () {
      return te.default;
    });
    var ee = n(107);
    n.d(e, "Link", function () {
      return ee.default;
    });
    var ne = n(108);
    n.d(e, "LinkSmall", function () {
      return ne.default;
    });
    var re = n(109);
    n.d(e, "Loader", function () {
      return re.default;
    });
    var ae = n(110);
    n.d(e, "Lock", function () {
      return ae.default;
    });
    var le = n(111);
    n.d(e, "Magic", function () {
      return le.default;
    });
    var ie = n(112);
    n.d(e, "Mail", function () {
      return ie.default;
    });
    var ce = n(113);
    n.d(e, "ManyToMany", function () {
      return ce.default;
    });
    var oe = n(114);
    n.d(e, "ManyToOne", function () {
      return oe.default;
    });
    var ue = n(115);
    n.d(e, "ManyWays", function () {
      return ue.default;
    });
    var fe = n(116);
    n.d(e, "Media", function () {
      return fe.default;
    });
    var he = n(117);
    n.d(e, "Medium", function () {
      return he.default;
    });
    var ve = n(118);
    n.d(e, "MenuBurger", function () {
      return ve.default;
    });
    var se = n(119);
    n.d(e, "Message", function () {
      return se.default;
    });
    var pe = n(120);
    n.d(e, "Microphone", function () {
      return pe.default;
    });
    var de = n(121);
    n.d(e, "Minus", function () {
      return de.default;
    });
    var we = n(122);
    n.d(e, "MinusOutlined", function () {
      return we.default;
    });
    var me = n(123);
    n.d(e, "Monitor", function () {
      return me.default;
    });
    var ge = n(124);
    n.d(e, "Moon", function () {
      return ge.default;
    });
    var ye = n(125);
    n.d(e, "More", function () {
      return ye.default;
    });
    var ze = n(126);
    n.d(e, "Move", function () {
      return ze.default;
    });
    var Oe = n(127);
    n.d(e, "Music", function () {
      return Oe.default;
    });
    var Ee = n(128);
    n.d(e, "Number", function () {
      return Ee.default;
    });
    var xe = n(129);
    n.d(e, "NumberList", function () {
      return xe.default;
    });
    var Me = n(130);
    n.d(e, "OneToMany", function () {
      return Me.default;
    });
    var be = n(131);
    n.d(e, "OneToOne", function () {
      return be.default;
    });
    var je = n(132);
    n.d(e, "OneWay", function () {
      return je.default;
    });
    var He = n(133);
    n.d(e, "OnholdCarretDown", function () {
      return He.default;
    });
    var Be = n(134);
    n.d(e, "OnholdCarretUp", function () {
      return Be.default;
    });
    var Ve = n(135);
    n.d(e, "Paint", function () {
      return Ve.default;
    });
    var Pe = n(136);
    n.d(e, "PaintBrush", function () {
      return Pe.default;
    });
    var Le = n(137);
    n.d(e, "PaperPlane", function () {
      return Le.default;
    });
    var Ae = n(138);
    n.d(e, "Password", function () {
      return Ae.default;
    });
    var Fe = n(139);
    n.d(e, "Pencil", function () {
      return Fe.default;
    });
    var Re = n(140);
    n.d(e, "Phone", function () {
      return Re.default;
    });
    var Ce = n(141);
    n.d(e, "Picture", function () {
      return Ce.default;
    });
    var De = n(142);
    n.d(e, "PicturePlus", function () {
      return De.default;
    });
    var ke = n(143);
    n.d(e, "Pin", function () {
      return ke.default;
    });
    var Se = n(144);
    n.d(e, "PinMap", function () {
      return Se.default;
    });
    var Te = n(145);
    n.d(e, "Plane", function () {
      return Te.default;
    });
    var We = n(146);
    n.d(e, "Play", function () {
      return We.default;
    });
    var _e = n(147);
    n.d(e, "PlaySquare", function () {
      return _e.default;
    });
    var Ue = n(148);
    n.d(e, "Plus", function () {
      return Ue.default;
    });
    var Ie = n(149);
    n.d(e, "PlusCircle", function () {
      return Ie.default;
    });
    var qe = n(150);
    n.d(e, "PriceTag", function () {
      return qe.default;
    });
    var Ge = n(151);
    n.d(e, "Puzzle", function () {
      return Ge.default;
    });
    var Qe = n(152);
    n.d(e, "Quote", function () {
      return Qe.default;
    });
    var Ne = n(153);
    n.d(e, "QuoteClosed", function () {
      return Ne.default;
    });
    var Je = n(154);
    n.d(e, "Reddit", function () {
      return Je.default;
    });
    var Ke = n(155);
    n.d(e, "Refresh", function () {
      return Ke.default;
    });
    var Ze = n(156);
    n.d(e, "Relation", function () {
      return Ze.default;
    });
    var Xe = n(157);
    n.d(e, "Repeat", function () {
      return Xe.default;
    });
    var Ye = n(158);
    n.d(e, "Restaurant", function () {
      return Ye.default;
    });
    var $e = n(159);
    n.d(e, "RichText", function () {
      return $e.default;
    });
    var tn = n(160);
    n.d(e, "Rocket", function () {
      return tn.default;
    });
    var en = n(161);
    n.d(e, "Scissors", function () {
      return en.default;
    });
    var nn = n(162);
    n.d(e, "Search", function () {
      return nn.default;
    });
    var rn = n(163);
    n.d(e, "SearchIcon", function () {
      return rn.default;
    });
    var an = n(164);
    n.d(e, "Seed", function () {
      return an.default;
    });
    var ln = n(165);
    n.d(e, "Server", function () {
      return ln.default;
    });
    var cn = n(166);
    n.d(e, "Shield", function () {
      return cn.default;
    });
    var on = n(167);
    n.d(e, "Shirt", function () {
      return on.default;
    });
    var un = n(168);
    n.d(e, "ShoppingCart", function () {
      return un.default;
    });
    var fn = n(169);
    n.d(e, "SingleType", function () {
      return fn.default;
    });
    var hn = n(170);
    n.d(e, "Slideshow", function () {
      return hn.default;
    });
    var vn = n(171);
    n.d(e, "Spinner", function () {
      return vn.default;
    });
    var sn = n(172);
    n.d(e, "Stack", function () {
      return sn.default;
    });
    var pn = n(173);
    n.d(e, "Star", function () {
      return pn.default;
    });
    var dn = n(174);
    n.d(e, "Store", function () {
      return dn.default;
    });
    var wn = n(175);
    n.d(e, "Strapi", function () {
      return wn.default;
    });
    var mn = n(176);
    n.d(e, "StrikeThrough", function () {
      return mn.default;
    });
    var gn = n(177);
    n.d(e, "Sun", function () {
      return gn.default;
    });
    var yn = n(178);
    n.d(e, "Television", function () {
      return yn.default;
    });
    var zn = n(179);
    n.d(e, "Text", function () {
      return zn.default;
    });
    var On = n(180);
    n.d(e, "ThumbDown", function () {
      return On.default;
    });
    var En = n(181);
    n.d(e, "ThumbUp", function () {
      return En.default;
    });
    var xn = n(182);
    n.d(e, "Train", function () {
      return xn.default;
    });
    var Mn = n(183);
    n.d(e, "Trash", function () {
      return Mn.default;
    });
    var bn = n(184);
    n.d(e, "Twitter", function () {
      return bn.default;
    });
    var jn = n(185);
    n.d(e, "Typhoon", function () {
      return jn.default;
    });
    var Hn = n(186);
    n.d(e, "Uid", function () {
      return Hn.default;
    });
    var Bn = n(187);
    n.d(e, "Underline", function () {
      return Bn.default;
    });
    var Vn = n(188);
    n.d(e, "Upload", function () {
      return Vn.default;
    });
    var Pn = n(189);
    n.d(e, "User", function () {
      return Pn.default;
    });
    var Ln = n(190);
    n.d(e, "VolumeMute", function () {
      return Ln.default;
    });
    var An = n(191);
    n.d(e, "VolumeUp", function () {
      return An.default;
    });
    var Fn = n(192);
    n.d(e, "Walk", function () {
      return Fn.default;
    });
    var Rn = n(193);
    n.d(e, "Wheelchair", function () {
      return Rn.default;
    });
    var Cn = n(194);
    n.d(e, "Write", function () {
      return Cn.default;
    });
  }]);
});